window.CHEM_KNOWLEDGE = {
  "seamlock pro i-transparent white - dripless sl9825": {
    "why_recommend": "Pre-colored transparent white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-white north - dripless sl9873": {
    "why_recommend": "Pre-colored white north methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-cygnus pearl - dripless sl9864": {
    "why_recommend": "Pre-colored cygnus pearl methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-crystal clear - dripless sl9863": {
    "why_recommend": "Pre-colored crystal clear methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-pure white - dripless sl9837": {
    "why_recommend": "Pre-colored pure white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-baby's breath - dripless sl9959": {
    "why_recommend": "Pre-colored baby's breath methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro anthracite - dripless sl9132": {
    "why_recommend": "Pre-colored anthracite methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro pebble stone color adhesive cartridge - dripless sl9237": {
    "why_recommend": "Pre-colored pebble methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro rhino stone color adhesive cartridge - dripless sl9238": {
    "why_recommend": "Pre-colored rhino methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro sterling adhesive for countertop seaming": {
    "why_recommend": "Pre-colored sterling methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro sahara stone color adhesive cartridge - dripless sl9240": {
    "why_recommend": "Pre-colored sahara methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro bavarian cream - dripless sl9241": {
    "why_recommend": "Pre-colored bavarian cream methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro timber wolf - dripless sl9259": {
    "why_recommend": "Pre-colored timber wolf methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro veil adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored veil methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro burl white - dripless sl9265": {
    "why_recommend": "Pre-colored burl white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro argento stone color adhesive cartridge - dripless sl9272": {
    "why_recommend": "Pre-colored argento methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro industrial - dripless sl9280": {
    "why_recommend": "Pre-colored industrial methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro steak red - dripless sl9453": {
    "why_recommend": "Pre-colored steak red methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-tuscan white - dripless sl9559": {
    "why_recommend": "Pre-colored tuscan white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro tower daybreak - dripless sl9572": {
    "why_recommend": "Pre-colored daybreak methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro tower frosty white - dripless sl9574": {
    "why_recommend": "Pre-colored frosty white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro tower nubuck - dripless sl9575": {
    "why_recommend": "Pre-colored nubuck methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro tower onias - dripless sl9576": {
    "why_recommend": "Pre-colored onias methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro tower vanilla - dripless sl9577": {
    "why_recommend": "Pre-colored vanilla methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro tower vellum - dripless sl9578": {
    "why_recommend": "Pre-colored vellum methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-crystal white - dripless sl9584": {
    "why_recommend": "Pre-colored crystal white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro raven stone color adhesive cartridge - dripless sl9645": {
    "why_recommend": "Pre-colored raven methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro blanco stone color adhesive cartridge - dripless sl9646": {
    "why_recommend": "Pre-colored blanco methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-wheat stone color adhesive cartridge - dripless sl9665": {
    "why_recommend": "Pre-colored wheat methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-sand dollar - dripless sl9677": {
    "why_recommend": "Pre-colored sand dollar methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-alabaster - dripless sl9679": {
    "why_recommend": "Pre-colored alabaster methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro mountain stone color adhesive cartridge - dripless sl9687": {
    "why_recommend": "Pre-colored mountain methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro birch stone color adhesive cartridge - dripless sl9689": {
    "why_recommend": "Pre-colored birch methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro clamshell - dripless sl9699": {
    "why_recommend": "Pre-colored clamshell methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro bone pro stone color adhesive cartridge - dripless sl9705": {
    "why_recommend": "Pre-colored bone pro methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-cocoa stone color adhesive cartridge - dripless sl9716": {
    "why_recommend": "Pre-colored cocoa methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-lunar stone color adhesive cartridge - dripless sl9751": {
    "why_recommend": "Pre-colored lunar methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-weaping willow - dripless sl9758": {
    "why_recommend": "Pre-colored weaping willow methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-lead stone color adhesive cartridge - dripless sl9761": {
    "why_recommend": "Pre-colored lead methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-coffee stone color adhesive cartridge - dripless sl9762": {
    "why_recommend": "Pre-colored coffee methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-wool stone color adhesive cartridge - dripless sl9763": {
    "why_recommend": "Pre-colored wool methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-lily white - dripless sl9768": {
    "why_recommend": "Pre-colored lily white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-sabbia stone color adhesive cartridge - dripless sl9772": {
    "why_recommend": "Pre-colored sabbia methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-sand stone color adhesive cartridge - dripless sl9331": {
    "why_recommend": "Pre-colored sand methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-pumice stone color adhesive cartridge - dripless sl9777": {
    "why_recommend": "Pre-colored pumice methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-warm grey - dripless sl9806": {
    "why_recommend": "Pre-colored warm grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-river rock - dripless sl9807": {
    "why_recommend": "Pre-colored river rock methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-suede stone color adhesive cartridge - dripless sl9898": {
    "why_recommend": "Pre-colored suede methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-dove stone color adhesive cartridge - dripless sl9915": {
    "why_recommend": "Pre-colored dove methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-cedar stone color adhesive cartridge - dripless sl9916": {
    "why_recommend": "Pre-colored cedar methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-bisquit - dripless sl9919": {
    "why_recommend": "Pre-colored bisquit methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro hadley stone color adhesive cartridge - dripless sl9930": {
    "why_recommend": "Pre-colored hadley methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro c neutral - dripless sl9943": {
    "why_recommend": "Pre-colored c neutral methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-polar stone color adhesive cartridge - dripless sl9945": {
    "why_recommend": "Pre-colored polar methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro silverite - dripless sl9950": {
    "why_recommend": "Pre-colored silverite methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-onyx stone color adhesive cartridge - dripless sl9953": {
    "why_recommend": "Pre-colored onyx methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-midnight - dripless sl9954": {
    "why_recommend": "Pre-colored midnight methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-raven stone color adhesive cartridge - dripless sl9955": {
    "why_recommend": "Pre-colored raven methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-balsa stone color adhesive cartridge - dripless sl9958": {
    "why_recommend": "Pre-colored balsa methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro nantucket - dripless sl9960": {
    "why_recommend": "Pre-colored nantucket methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-ash stone color adhesive cartridge - dripless sl9961": {
    "why_recommend": "Pre-colored ash methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro uliano adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored uliano methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro messina stone color adhesive cartridge - dripless sl9993": {
    "why_recommend": "Pre-colored messina methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro salo stone color adhesive cartridge - dripless sl9995": {
    "why_recommend": "Pre-colored salo methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro winter adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored winter methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro bright stone color adhesive cartridge - dripless sl9102": {
    "why_recommend": "Pre-colored bright methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro brilliant - dripless sl9103": {
    "why_recommend": "Pre-colored brilliant methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro cotton stone color adhesive cartridge - dripless sl9104": {
    "why_recommend": "Pre-colored cotton methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro vanilla adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored vanilla methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro marble stone color adhesive cartridge - dripless sl9106": {
    "why_recommend": "Pre-colored marble methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro porcelain - dripless sl9107": {
    "why_recommend": "Pre-colored porcelain methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro snow adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored snow methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro antique stone seam adhesive -- dripless sl9109": {
    "why_recommend": "Pre-colored antique stone seam methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro satin stone color adhesive cartridge - dripless sl9110": {
    "why_recommend": "Pre-colored satin methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro glacier stone color adhesive cartridge - dripless sl9111": {
    "why_recommend": "Pre-colored glacier methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro canvas stone color adhesive cartridge - dripless sl9112": {
    "why_recommend": "Pre-colored canvas methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro blizzard stone color adhesive cartridge - dripless sl9113": {
    "why_recommend": "Pre-colored blizzard methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro opal stone color adhesive cartridge - dripless sl9114": {
    "why_recommend": "Pre-colored opal methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro ghost stone color adhesive cartridge - dripless sl9115": {
    "why_recommend": "Pre-colored ghost methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro newport stone color adhesive cartridge - dripless sl9116": {
    "why_recommend": "Pre-colored newport methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro designer white - dripless sl9117": {
    "why_recommend": "Pre-colored designer white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro cloud stone color adhesive cartridge - dripless sl9118": {
    "why_recommend": "Pre-colored cloud methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro white adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro cameo stone color adhesive cartridge - dripless sl9120": {
    "why_recommend": "Pre-colored cameo methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro arctic stone color adhesive cartridge - dripless sl9121": {
    "why_recommend": "Pre-colored arctic methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro inf8701 stone color adhesive cartridge - dripless sl9122": {
    "why_recommend": "Pre-colored inf8701 methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro sterling white - dripless sl9125": {
    "why_recommend": "Pre-colored sterling white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro clear stone color adhesive cartridge - dripless sl9199": {
    "why_recommend": "Pre-colored clear methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro fog stone color adhesive cartridge - dripless sl9200": {
    "why_recommend": "Pre-colored fog methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro buff stone color adhesive cartridge - dripless sl9210": {
    "why_recommend": "Pre-colored buff methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro natural stone color adhesive cartridge - dripless sl9214": {
    "why_recommend": "Pre-colored natural methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro sand stone color adhesive cartridge - dripless sl9216": {
    "why_recommend": "Pre-colored sand methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro ice stone color adhesive cartridge - dripless sl9218": {
    "why_recommend": "Pre-colored ice methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro misty stone color adhesive cartridge - dripless sl9220": {
    "why_recommend": "Pre-colored misty methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro stone adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored stone methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro blonde stone color adhesive cartridge - dripless sl9225": {
    "why_recommend": "Pre-colored blonde methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro butter stone color adhesive cartridge - dripless sl9226": {
    "why_recommend": "Pre-colored butter methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro beach stone color adhesive cartridge - dripless sl9230": {
    "why_recommend": "Pre-colored beach methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro manilla stone color adhesive cartridge - dripless sl9231": {
    "why_recommend": "Pre-colored manilla methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro cream stone color adhesive cartridge - dripless sl9232": {
    "why_recommend": "Pre-colored cream methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro caramel stone color adhesive cartridge - dripless sl9234": {
    "why_recommend": "Pre-colored caramel methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro torano adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored torano methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro khaki stone color adhesive cartridge - dripless sl9236": {
    "why_recommend": "Pre-colored khaki methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro warm nature - dripless sl9277": {
    "why_recommend": "Pre-colored warm nature methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro grey nature - dripless sl9278": {
    "why_recommend": "Pre-colored grey nature methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro redfire stone color adhesive cartridge - dripless sl9279": {
    "why_recommend": "Pre-colored redfire methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro serene stone color adhesive cartridge - dripless sl9304": {
    "why_recommend": "Pre-colored serene methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro dune stone color adhesive cartridge - dripless sl9310": {
    "why_recommend": "Pre-colored dune methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro latte stone color adhesive cartridge - dripless sl9312": {
    "why_recommend": "Pre-colored latte methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro willow adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored willow methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro fawn stone color adhesive cartridge - dripless sl9316": {
    "why_recommend": "Pre-colored fawn methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro sonora adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored sonora methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro toffee adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored toffee methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro mocha stone color adhesive cartridge - dripless sl9322": {
    "why_recommend": "Pre-colored mocha methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro cocoa stone color adhesive cartridge - dripless sl9323": {
    "why_recommend": "Pre-colored cocoa methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro chocolate - dripless sl9324": {
    "why_recommend": "Pre-colored chocolate methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro suede adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored suede methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro auburn stone color adhesive cartridge - dripless sl9330": {
    "why_recommend": "Pre-colored auburn methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro roast stone color adhesive cartridge - dripless sl9332": {
    "why_recommend": "Pre-colored roast methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro sunshine adhesive for countertop seaming": {
    "why_recommend": "Pre-colored sunshine methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro orange zest - dripless sl9415": {
    "why_recommend": "Pre-colored orange zest methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro copper stone color adhesive cartridge - dripless sl9418": {
    "why_recommend": "Pre-colored copper methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro rust stone color adhesive cartridge - dripless sl9424": {
    "why_recommend": "Pre-colored rust methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro hazel stone color adhesive cartridge - dripless sl9432": {
    "why_recommend": "Pre-colored hazel methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro fuego stone color adhesive cartridge - dripless sl9450": {
    "why_recommend": "Pre-colored fuego methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro red stone color adhesive cartridge - dripless sl9451": {
    "why_recommend": "Pre-colored red methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro red lava stone color adhesive cartridge - dripless sl9452": {
    "why_recommend": "Pre-colored red lava methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro universe adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored universe methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro skye adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored skye methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro elbert stone color adhesive cartridge - dripless sl9505": {
    "why_recommend": "Pre-colored elbert methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro urban grey - dripless sl9506": {
    "why_recommend": "Pre-colored urban grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro splendor gray - dripless sl9507": {
    "why_recommend": "Pre-colored splendor gray methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro titanium grey - dripless sl9508": {
    "why_recommend": "Pre-colored titanium grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro dove shimmer - dripless sl9509": {
    "why_recommend": "Pre-colored dove shimmer methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro pearl stone color adhesive cartridge - dripless sl9510": {
    "why_recommend": "Pre-colored pearl methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro archer grey - dripless sl9511": {
    "why_recommend": "Pre-colored archer grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro slate adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored slate methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro gray s005 - dripless sl9513": {
    "why_recommend": "Pre-colored gray s005 methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro ore stone color adhesive cartridge - dripless sl9515": {
    "why_recommend": "Pre-colored ore methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro prairie stone color adhesive cartridge - dripless sl9516": {
    "why_recommend": "Pre-colored prairie methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro concrete gray - dripless sl9517": {
    "why_recommend": "Pre-colored concrete gray methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro pewter stone color adhesive cartridge - dripless sl9518": {
    "why_recommend": "Pre-colored pewter methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro mist gray - dripless sl9519": {
    "why_recommend": "Pre-colored mist gray methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro olive stone color adhesive cartridge - dripless sl9520": {
    "why_recommend": "Pre-colored olive methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro lava stone color adhesive cartridge - dripless sl9521": {
    "why_recommend": "Pre-colored lava methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro thunder adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored thunder methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro smoke adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored smoke methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro deep cloud - dripless sl9524": {
    "why_recommend": "Pre-colored deep cloud methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro shale adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored shale methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro clay stone color adhesive cartridge - dripless sl9526": {
    "why_recommend": "Pre-colored clay methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro new concrete - dripless sl9527": {
    "why_recommend": "Pre-colored new concrete methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro espresso stone color adhesive cartridge - dripless sl9528": {
    "why_recommend": "Pre-colored espresso methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro oyster stone color adhesive cartridge - dripless sl9529": {
    "why_recommend": "Pre-colored oyster methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro coal stone color adhesive cartridge - dripless sl9530": {
    "why_recommend": "Pre-colored coal methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro sable stone color adhesive cartridge - dripless sl9531": {
    "why_recommend": "Pre-colored sable methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro midnight stone color adhesive cartridge - dripless sl9532": {
    "why_recommend": "Pre-colored midnight methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro titanium adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored titanium methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro pitch stone color adhesive cartridge - dripless sl9534": {
    "why_recommend": "Pre-colored pitch methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-snow white - dripless sl9537": {
    "why_recommend": "Pre-colored snow white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro tornado gray - dripless sl9538": {
    "why_recommend": "Pre-colored tornado gray methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-sandstone - dripless sl9539": {
    "why_recommend": "Pre-colored sandstone methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro antique blue - dripless sl9540": {
    "why_recommend": "Pre-colored antique blue methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro placid stone color adhesive cartridge - dripless sl9541": {
    "why_recommend": "Pre-colored placid methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-fieldstone - dripless sl9776": {
    "why_recommend": "Pre-colored fieldstone methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro green stone color adhesive cartridge - dripless sl9560": {
    "why_recommend": "Pre-colored green methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro cherry pink - dripless sl9561": {
    "why_recommend": "Pre-colored cherry pink methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro horizon haze - dripless sl9562": {
    "why_recommend": "Pre-colored horizon haze methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro tower bisque - dripless sl9570": {
    "why_recommend": "Pre-colored bisque methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro tower bone - dripless sl9571": {
    "why_recommend": "Pre-colored bone methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro tower designer white - dripless sl9573": {
    "why_recommend": "Pre-colored designer white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro nova stone color adhesive cartridge - dripless sl9582": {
    "why_recommend": "Pre-colored nova methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro design stone color adhesive cartridge - dripless sl9601": {
    "why_recommend": "Pre-colored design methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro frosty stone color adhesive cartridge - dripless sl9603": {
    "why_recommend": "Pre-colored frosty methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro mesa stone color adhesive cartridge - dripless sl9604": {
    "why_recommend": "Pre-colored mesa methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro umber adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored umber methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro pudding stone color adhesive cartridge - dripless sl9606": {
    "why_recommend": "Pre-colored pudding methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro adobe stone seam adhesive -- dripless sl9608": {
    "why_recommend": "Pre-colored adobe stone seam methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro camel stone color adhesive cartridge - dripless sl9610": {
    "why_recommend": "Pre-colored camel methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro sun color adhesive for countertop seaming": {
    "why_recommend": "Pre-colored sun color methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro hot stone color adhesive cartridge - dripless sl9617": {
    "why_recommend": "Pre-colored hot methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro mandarin stone color adhesive cartridge - dripless sl9619": {
    "why_recommend": "Pre-colored mandarin methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro fire stone color adhesive cartridge - dripless sl9621": {
    "why_recommend": "Pre-colored fire methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro silver adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored silver methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro ash stone color adhesive cartridge - dripless sl9623": {
    "why_recommend": "Pre-colored ash methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro malt stone color adhesive cartridge - dripless sl9624": {
    "why_recommend": "Pre-colored malt methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro charcoal stone color adhesive cartridge - dripless sl9625": {
    "why_recommend": "Pre-colored charcoal methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro flax stone color adhesive cartridge - dripless sl9627": {
    "why_recommend": "Pre-colored flax methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro earth stone color adhesive cartridge - dripless sl9628": {
    "why_recommend": "Pre-colored earth methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro lime stone color adhesive cartridge - dripless sl9632": {
    "why_recommend": "Pre-colored lime methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro orange stone color adhesive cartridge - dripless sl9633": {
    "why_recommend": "Pre-colored orange methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro nutmeg stone color adhesive cartridge - dripless sl9635": {
    "why_recommend": "Pre-colored nutmeg methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro oregano stone color adhesive cartridge - dripless sl9636": {
    "why_recommend": "Pre-colored oregano methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro ecru stone color adhesive cartridge - dripless sl9637": {
    "why_recommend": "Pre-colored ecru methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro nickel stone color adhesive cartridge - dripless sl9638": {
    "why_recommend": "Pre-colored nickel methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro chai stone color adhesive cartridge - dripless sl9639": {
    "why_recommend": "Pre-colored chai methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro riverstone - dripless sl9641": {
    "why_recommend": "Pre-colored riverstone methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro aluminum stone seam adhesive -- dripless sl9642": {
    "why_recommend": "Pre-colored aluminum stone seam methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro coffee stone color adhesive cartridge - dripless sl9643": {
    "why_recommend": "Pre-colored coffee methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro chestnut stone color adhesive cartridge - dripless sl9644": {
    "why_recommend": "Pre-colored chestnut methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro moss stone color adhesive cartridge - dripless sl9647": {
    "why_recommend": "Pre-colored moss methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro toscana adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored toscana methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro meridian stone color adhesive cartridge - dripless sl9649": {
    "why_recommend": "Pre-colored meridian methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro banana stone color adhesive cartridge - dripless sl9650": {
    "why_recommend": "Pre-colored banana methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro bala blue - dripless sl9652": {
    "why_recommend": "Pre-colored bala blue methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro dover stone color adhesive cartridge - dripless sl9653": {
    "why_recommend": "Pre-colored dover methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro devon stone color adhesive cartridge - dripless sl9654": {
    "why_recommend": "Pre-colored devon methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro whisper adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored whisper methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro silt adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored silt methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro laguna stone color adhesive cartridge - dripless sl9658": {
    "why_recommend": "Pre-colored laguna methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro cherry stone color adhesive cartridge - dripless sl9662": {
    "why_recommend": "Pre-colored cherry methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro honeydew stone color adhesive cartridge - dripless sl9663": {
    "why_recommend": "Pre-colored honeydew methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro pomegranite - dripless sl9666": {
    "why_recommend": "Pre-colored pomegranite methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro rossa stone color adhesive cartridge - dripless sl9667": {
    "why_recommend": "Pre-colored rossa methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro wood adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored wood methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro delfino stone color adhesive cartridge - dripless sl9671": {
    "why_recommend": "Pre-colored delfino methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro shell adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored shell methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro clam stone color adhesive cartridge - dripless sl9673": {
    "why_recommend": "Pre-colored clam methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro mojave stone color adhesive cartridge - dripless sl9674": {
    "why_recommend": "Pre-colored mojave methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro danae stone color adhesive cartridge - dripless sl9675": {
    "why_recommend": "Pre-colored danae methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro leather stone color adhesive cartridge - dripless sl9678": {
    "why_recommend": "Pre-colored leather methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro marta stone color adhesive cartridge - dripless sl9680": {
    "why_recommend": "Pre-colored marta methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro flannel stone color adhesive cartridge - dripless sl9682": {
    "why_recommend": "Pre-colored flannel methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro sand storm - dripless sl9683": {
    "why_recommend": "Pre-colored sand storm methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro botticino - dripless sl9684": {
    "why_recommend": "Pre-colored botticino methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro happy red - dripless sl9691": {
    "why_recommend": "Pre-colored happy red methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro hemp stone color adhesive cartridge - dripless sl9692": {
    "why_recommend": "Pre-colored hemp methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro crimson stone color adhesive cartridge - dripless sl9693": {
    "why_recommend": "Pre-colored crimson methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro tierra adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored tierra methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro battleship - dripless sl9718": {
    "why_recommend": "Pre-colored battleship methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro conche stone color adhesive cartridge - dripless sl9719": {
    "why_recommend": "Pre-colored conche methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro naranja stone color adhesive cartridge - dripless sl9729": {
    "why_recommend": "Pre-colored naranja methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro bronze stone color adhesive cartridge - dripless sl9731": {
    "why_recommend": "Pre-colored bronze methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro sandshire - dripless sl9732": {
    "why_recommend": "Pre-colored sandshire methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro sussex adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored sussex methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro reading stone color adhesive cartridge - dripless sl9735": {
    "why_recommend": "Pre-colored reading methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro brownie stone color adhesive cartridge - dripless sl9736": {
    "why_recommend": "Pre-colored brownie methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro shadow adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored shadow methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro celestial - dripless sl9739": {
    "why_recommend": "Pre-colored celestial methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-trufa stone color adhesive cartridge - dripless sl9742": {
    "why_recommend": "Pre-colored trufa methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-glacier white - dripless sl9747": {
    "why_recommend": "Pre-colored glacier white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-bisque stone color adhesive cartridge - dripless sl9748": {
    "why_recommend": "Pre-colored bisque methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro butternut - dripless sl9752": {
    "why_recommend": "Pre-colored butternut methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro vicenza adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored vicenza methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro tempest adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored tempest methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-marone stone color adhesive cartridge - dripless sl9766": {
    "why_recommend": "Pre-colored marone methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-cotton stone color adhesive cartridge - dripless sl9770": {
    "why_recommend": "Pre-colored cotton methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-raton stone color adhesive cartridge - dripless sl9774": {
    "why_recommend": "Pre-colored raton methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-nacreto - dripless sl9778": {
    "why_recommend": "Pre-colored nacreto methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-arctic white - dripless sl9780": {
    "why_recommend": "Pre-colored arctic white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-cinder stone color adhesive cartridge - dripless sl9781": {
    "why_recommend": "Pre-colored cinder methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-ginger stone color adhesive cartridge - dripless sl9782": {
    "why_recommend": "Pre-colored ginger methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-graphite - dripless sl9783": {
    "why_recommend": "Pre-colored graphite methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-medea stone color adhesive cartridge - dripless sl9784": {
    "why_recommend": "Pre-colored medea methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-polar white - dripless sl9785": {
    "why_recommend": "Pre-colored polar white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-white linen - dripless sl9786": {
    "why_recommend": "Pre-colored white linen methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-winter white - dripless sl9787": {
    "why_recommend": "Pre-colored winter white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-champagne - dripless sl9788": {
    "why_recommend": "Pre-colored champagne methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-cinnamon spice - dripless sl9789": {
    "why_recommend": "Pre-colored cinnamon spice methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-giallo stone color adhesive cartridge - dripless sl9792": {
    "why_recommend": "Pre-colored giallo methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-iron grey - dripless sl9794": {
    "why_recommend": "Pre-colored iron grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-natural almond - dripless sl9795": {
    "why_recommend": "Pre-colored natural almond methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-natural grey - dripless sl9796": {
    "why_recommend": "Pre-colored natural grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-nougat stone color adhesive cartridge - dripless sl9797": {
    "why_recommend": "Pre-colored nougat methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-seashell - dripless sl9798": {
    "why_recommend": "Pre-colored seashell methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-tan stone color adhesive cartridge - dripless sl9799": {
    "why_recommend": "Pre-colored tan methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-chameleon - dripless sl9800": {
    "why_recommend": "Pre-colored chameleon methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-casper stone color adhesive cartridge - dripless sl9801": {
    "why_recommend": "Pre-colored casper methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-dawn stone color adhesive cartridge - dripless sl9802": {
    "why_recommend": "Pre-colored dawn methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-taupe stone color adhesive cartridge - dripless sl9803": {
    "why_recommend": "Pre-colored taupe methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-boulder - dripless sl9810": {
    "why_recommend": "Pre-colored boulder methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-flint stone color adhesive cartridge - dripless sl9811": {
    "why_recommend": "Pre-colored flint methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-white chocolate - dripless sl9813": {
    "why_recommend": "Pre-colored white chocolate methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-pewter stone color adhesive cartridge - dripless sl9814": {
    "why_recommend": "Pre-colored pewter methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-pearl grey - dripless sl9815": {
    "why_recommend": "Pre-colored pearl grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-bone stone color adhesive cartridge - dripless sl9816": {
    "why_recommend": "Pre-colored bone methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-cocoa brown - dripless sl9818": {
    "why_recommend": "Pre-colored cocoa brown methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-slate stone color adhesive cartridge - dripless sl9819": {
    "why_recommend": "Pre-colored slate methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-earth brown - dripless sl9820": {
    "why_recommend": "Pre-colored earth brown methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-sage stone color adhesive cartridge - dripless sl9821": {
    "why_recommend": "Pre-colored sage methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-bright white - dripless sl9822": {
    "why_recommend": "Pre-colored bright white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-charcoal - dripless sl9823": {
    "why_recommend": "Pre-colored charcoal methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-butterscotch - dripless sl9824": {
    "why_recommend": "Pre-colored butterscotch methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-magic stone color adhesive cartridge - dripless sl9826": {
    "why_recommend": "Pre-colored magic methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-satin black - dripless sl9827": {
    "why_recommend": "Pre-colored satin black methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-khaki stone color adhesive cartridge - dripless sl9828": {
    "why_recommend": "Pre-colored khaki methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-acorn stone color adhesive cartridge - dripless sl9829": {
    "why_recommend": "Pre-colored acorn methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-toffee stone color adhesive cartridge - dripless sl9830": {
    "why_recommend": "Pre-colored toffee methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-aqueous - dripless sl9831": {
    "why_recommend": "Pre-colored aqueous methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-ash stone color adhesive cartridge - dripless sl9832": {
    "why_recommend": "Pre-colored ash methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-autumn light - dripless sl9833": {
    "why_recommend": "Pre-colored autumn light methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-beach stone color adhesive cartridge - dripless sl9834": {
    "why_recommend": "Pre-colored beach methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-cambrian gold - dripless sl9835": {
    "why_recommend": "Pre-colored cambrian gold methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-desert stone color adhesive cartridge - dripless sl9836": {
    "why_recommend": "Pre-colored desert methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-espresso - dripless sl9838": {
    "why_recommend": "Pre-colored espresso methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-lunar pearl - dripless sl9842": {
    "why_recommend": "Pre-colored lunar pearl methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-natural - dripless sl9844": {
    "why_recommend": "Pre-colored natural methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-pearl stone color adhesive cartridge - dripless sl9845": {
    "why_recommend": "Pre-colored pearl methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-pudding brown - dripless sl9846": {
    "why_recommend": "Pre-colored pudding brown methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-rambone - dripless sl9847": {
    "why_recommend": "Pre-colored rambone methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-rhin stone color adhesive cartridge - dripless sl9848": {
    "why_recommend": "Pre-colored rhin methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro oat stone color adhesive cartridge - dripless sl9850": {
    "why_recommend": "Pre-colored oat methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-silver stone color adhesive cartridge - dripless sl9851": {
    "why_recommend": "Pre-colored silver methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-storm grey - dripless sl9852": {
    "why_recommend": "Pre-colored storm grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-thunder grey - dripless sl9853": {
    "why_recommend": "Pre-colored thunder grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-tidal sand - dripless sl9854": {
    "why_recommend": "Pre-colored tidal sand methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-tusk stone color adhesive cartridge - dripless sl9855": {
    "why_recommend": "Pre-colored tusk methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-uba tuba - dripless sl9856": {
    "why_recommend": "Pre-colored uba tuba methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-transparent black - dripless sl9857": {
    "why_recommend": "Pre-colored transparent black methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-aztec gold - dripless sl9858": {
    "why_recommend": "Pre-colored aztec gold methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-amarillo - dripless sl9861": {
    "why_recommend": "Pre-colored amarillo methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-coffee stone color adhesive cartridge - dripless sl9862": {
    "why_recommend": "Pre-colored coffee methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-dusk stone color adhesive cartridge - dripless sl9865": {
    "why_recommend": "Pre-colored dusk methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-mocha stone color adhesive cartridge - dripless sl9867": {
    "why_recommend": "Pre-colored mocha methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-neutral - dripless sl9868": {
    "why_recommend": "Pre-colored neutral methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-newport grey - dripless sl9869": {
    "why_recommend": "Pre-colored newport grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-stellar grey - dripless sl9871": {
    "why_recommend": "Pre-colored stellar grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-white stone color adhesive cartridge - dripless sl9872": {
    "why_recommend": "Pre-colored white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-absolute grey - dripless sl9874": {
    "why_recommend": "Pre-colored absolute grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-alabaster - dripless sl9875": {
    "why_recommend": "Pre-colored alabaster methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-amazon stone color adhesive cartridge - dripless sl9876": {
    "why_recommend": "Pre-colored amazon methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-beige olimpo - dripless sl9878": {
    "why_recommend": "Pre-colored beige olimpo methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-black stone color adhesive cartridge - dripless sl9879": {
    "why_recommend": "Pre-colored black methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-brazilian brown - dripless sl9881": {
    "why_recommend": "Pre-colored brazilian brown methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-brie stone color adhesive cartridge - dripless sl9882": {
    "why_recommend": "Pre-colored brie methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-cloud stone color adhesive cartridge - dripless sl9883": {
    "why_recommend": "Pre-colored cloud methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-concrete - dripless sl9884": {
    "why_recommend": "Pre-colored concrete methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-diana pearl - dripless sl9885": {
    "why_recommend": "Pre-colored diana pearl methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-galaxy black - dripless sl9886": {
    "why_recommend": "Pre-colored galaxy black methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-jet black - dripless sl9887": {
    "why_recommend": "Pre-colored jet black methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-limestone - dripless sl9888": {
    "why_recommend": "Pre-colored limestone methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-mercury grey - dripless sl9889": {
    "why_recommend": "Pre-colored mercury grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-meteor grey - dripless sl9890": {
    "why_recommend": "Pre-colored meteor grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-newgale grey - dripless sl9891": {
    "why_recommend": "Pre-colored newgale grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-onyx stone color adhesive cartridge - dripless sl9892": {
    "why_recommend": "Pre-colored onyx methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-oyster stone color adhesive cartridge - dripless sl9893": {
    "why_recommend": "Pre-colored oyster methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-perfect white - dripless sl9894": {
    "why_recommend": "Pre-colored perfect white methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-sahara stone color adhesive cartridge - dripless sl9895": {
    "why_recommend": "Pre-colored sahara methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-vega rose - dripless sl9896": {
    "why_recommend": "Pre-colored vega rose methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-zenith stone color adhesive cartridge - dripless sl9897": {
    "why_recommend": "Pre-colored zenith methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-vela brown - dripless sl9899": {
    "why_recommend": "Pre-colored vela brown methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-quarry stone color adhesive cartridge - dripless sl9900": {
    "why_recommend": "Pre-colored quarry methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro brume stone color adhesive cartridge - dripless sl9904": {
    "why_recommend": "Pre-colored brume methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro jungle stone color adhesive cartridge - dripless sl9905": {
    "why_recommend": "Pre-colored jungle methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro mango stone color adhesive cartridge - dripless sl9906": {
    "why_recommend": "Pre-colored mango methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro apple stone seam adhesive -- dripless sl9907": {
    "why_recommend": "Pre-colored apple stone seam methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro putty stone color adhesive cartridge - dripless sl9908": {
    "why_recommend": "Pre-colored putty methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro blue stone color adhesive cartridge - dripless sl9909": {
    "why_recommend": "Pre-colored blue methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro vino adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored vino methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro azul stone color adhesive cartridge - dripless sl9911": {
    "why_recommend": "Pre-colored azul methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro carbon stone color adhesive cartridge - dripless sl9912": {
    "why_recommend": "Pre-colored carbon methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro rain stone color adhesive cartridge - dripless sl9913": {
    "why_recommend": "Pre-colored rain methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro grey stone color adhesive cartridge - dripless sl9917": {
    "why_recommend": "Pre-colored grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro rouge stone color adhesive cartridge - dripless sl9920": {
    "why_recommend": "Pre-colored rouge methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro gris stone color adhesive cartridge - dripless sl9925": {
    "why_recommend": "Pre-colored gris methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro tan color adhesive for countertop seaming": {
    "why_recommend": "Pre-colored tan color methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro tawny adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored tawny methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro pink stone color adhesive cartridge - dripless sl9931": {
    "why_recommend": "Pre-colored pink methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro fossil stone color adhesive cartridge - dripless sl9946": {
    "why_recommend": "Pre-colored fossil methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-steel grey - dripless sl9947": {
    "why_recommend": "Pre-colored steel grey methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro pea stone color adhesive cartridge - dripless sl9951": {
    "why_recommend": "Pre-colored pea methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro emperador - dripless sl9966": {
    "why_recommend": "Pre-colored emperador methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro paprika stone color adhesive cartridge - dripless sl9967": {
    "why_recommend": "Pre-colored paprika methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro coral stone color adhesive cartridge - dripless sl9977": {
    "why_recommend": "Pre-colored coral methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro nirvana stone color adhesive cartridge - dripless sl9978": {
    "why_recommend": "Pre-colored nirvana methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro moose stone color adhesive cartridge - dripless sl9979": {
    "why_recommend": "Pre-colored moose methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro bourbon stone color adhesive cartridge - dripless sl9985": {
    "why_recommend": "Pre-colored bourbon methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro bento stone color adhesive cartridge - dripless sl9986": {
    "why_recommend": "Pre-colored bento methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro mystic gray - dripless sl9988": {
    "why_recommend": "Pre-colored mystic gray methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro marmi stone color adhesive cartridge - dripless sl9989": {
    "why_recommend": "Pre-colored marmi methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro dark roast - dripless sl9990": {
    "why_recommend": "Pre-colored dark roast methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "big dog seamlock pro wax adhesive for stone countertop seaming": {
    "why_recommend": "Pre-colored wax methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-crystal clear - dripless sl9999": {
    "why_recommend": "Pre-colored crystal clear methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro p-slate stone color adhesive cartridge - dripless sl9760": {
    "why_recommend": "Pre-colored slate methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "seamlock pro i-oxford brown - dripless sl9476": {
    "why_recommend": "Pre-colored oxford brown methacrylate cartridge adhesive for invisible color-matched seams. 10:1 mix, 8-12 min work time, 20-25 min cure. UV-stable, non-yellowing. Works on granite, marble, quartzite, engineered, quartz, sintered, porcelain, solid surface, cultured marble, glass. Interior only.",
    "application_tip": "1) Clean both surfaces with acetone, ensure dry and dust-free. 2) Load cartridge into dispensing gun, attach mixing tip. 3) Dispense directly into seam, slightly overfilling. 4) Working time: 8-12  min.Clamp seam immediately. 5) Razor scrape excess at gel stage (20-25 min). Sand and polish to match.",
    "warnings": [
      "Eye irritant.",
      "Exothermic reaction."
    ],
    "source_urls": [
      "https://www.bigdogadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax colored knife grade polyester - professional grade": {
    "why_recommend": "Tenax knife-grade polyester adhesive. Stays in place on vertical surfaces. Cure , mix 100:2-3 (resin to hardener by weight). For fissures, laminating, repair, seaming on engineered, granite, marble. Interior only. Available in multiple pre-tinted colors.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 100:2-3 (resin to hardener by weight). Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: (see TDS). Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: (see TDS). Sand from 220-grit up and polish to match.",
    "warnings": [
      "Interior only - not UV stable.",
      "Requires Tenax hardener.",
      "May yellow on light-colored marble over time.",
      "Available in multiple pre-tinted colors."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax titanium transparent knife grade vinylester glue - 1 gallon": {
    "why_recommend": "Tenax vinyl-ester with low yellowing, superior color stability. knife-grade, cure 15 min. For fissures, laminating, mitering, repair, seaming on engineered, granite, marble, porcelain, quartzite. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Mix resin with catalyst at 100:2-3 (resin to catalyst by weight). Stir thoroughly. 3) Apply with spatula, slightly overfilling. Clamp seams. 4) Working time: 4-5 min (gel time) min. 5) Razor scrape at gel stage. Full cure: 15 min min.15 min. Sand and polish.",
    "warnings": [
      "Low yellowing but formulated for UV resistance.",
      "Store between 68-77F.",
      "12-month shelf life.",
      "1 gallon size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax strong edge professional stone adhesive system": {
    "why_recommend": "Tenax two-part epoxy, structural bond strength. 2:1 mix, working, ~45 min at 75F full cure. For laminating, mitering, seaming on engineered, granite, marble, porcelain, quartzite. Suitable for vertical and horizontal applications. Interior only. Polishable.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Mix resin and hardener at 2:1. Stir 60 seconds. 3) Apply to both surfaces. Clamp firmly. 4) Working time: (see TDS). Do not disturb after. 5) Full cure: ~45 min at 75F min. Sand from 220-grit up and polish.",
    "warnings": [
      "Strongest clear knife-grade epoxy in Tenax line.",
      "Does not shrink.",
      "Prevents delamination.",
      "Long cure time compared to polyester adhesives.",
      "Polishable."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax domo epoxy adhesive for stone fabrication": {
    "why_recommend": "Tenax two-part epoxy, structural bond strength. 1:1 mix, ~2.5 hours (gel time at 77F) working, 24 hours (full cure); tack-free ~4 hours full cure. For anchoring, laminating, repair, seaming, substrate-bonding on concrete, engineered, granite, marble, porcelain. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Mix resin and hardener at 1:1. Stir 60 seconds. 3) Apply to both surfaces. Clamp firmly. 4) Working time: ~2.5 hours (gel time at 77F) min. Do not disturb after. 5) Full cure: 24 hours (full cure); tack-free ~4 hours. Sand from 220-grit up and polish.",
    "warnings": [
      "Colors easily with Tenax pigments.",
      "Bonds to polished and damp surfaces.",
      "VOC compliant.",
      "2-year shelf life at 65-77F.",
      "Long cure time compared to polyester adhesives."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax multibond acrylic cartridge adhesive 250 ml - styrene-free color match for stone": {
    "why_recommend": "Tenax acrylic (methacrylate) adhesive. gel. For laminating, seaming on engineered, granite, marble, porcelain, sintered.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (10:1 (pre-dosed cartridge)). 3) Apply evenly. 4) Working time: (see TDS). 5) Full cure: (see TDS).",
    "warnings": [
      "Styrene-free formula.",
      "Dripless - suitable for vertical surfaces.",
      "Requires Tenax 10:1 cartridge gun.",
      "Super flexible."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax transparent flowing polyester adhesive big box (4 x 1.25 gallon)": {
    "why_recommend": "Tenax flowing polyester adhesive. Self-levels into joints. Cure , mix 100:2-3 (resin to hardener by weight). For fissures, laminating, repair, seaming on engineered, granite, marble, quartzite. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 100:2-3 (resin to hardener by weight). Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: (see TDS). Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: (see TDS). Sand from 220-grit up and polish to match. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Interior only - not UV stable.",
      "Horizontal application only due to flowing consistency.",
      "Big box: 4 x 1.25 gallon.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax vertigo s colorless knife grade vinyl ester big box (4 x 1.25 gallon)": {
    "why_recommend": "Tenax vinyl-ester with low yellowing, superior color stability. knife-grade, cure 25 min. For fissures, laminating, mitering, repair, seaming on engineered, granite, marble, porcelain, quartzite, sintered. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Mix resin with catalyst at 100:2-3 (resin to catalyst by weight). Stir thoroughly. 3) Apply with spatula, slightly overfilling. Clamp seams. 4) Working time: 4-5 min (gel time) min. 5) Razor scrape at gel stage. Full cure: 25 min min.25 min. Sand and polish.",
    "warnings": [
      "Low yellowing - formulated for UV resistance.",
      "Drip-less formula.",
      "Big box: 4 x 1.25 gallon."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tixo ex transparent knife grade adhesive 17 kg": {
    "why_recommend": "Tenax knife-grade polyester adhesive. Stays in place on vertical surfaces. Cure , mix 100:2-3 (resin to hardener by weight). For fissures, laminating, repair, seaming on engineered, granite, marble. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 100:2-3 (resin to hardener by weight). Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: (see TDS). Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: (see TDS). Sand from 220-grit up and polish to match.",
    "warnings": [
      "Interior only - not UV stable.",
      "17 kg bulk pail.",
      "May yellow on light-colored marble over time."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax flowing titanium vinyl ester adhesive for granite and marble lamination": {
    "why_recommend": "Tenax vinyl-ester with low yellowing, superior color stability. flowing, cure 15 min. For fissures, laminating, repair, seaming on engineered, granite, marble, quartzite.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Mix resin with catalyst at 100:2-3 (resin to catalyst by weight). Stir thoroughly. 3) Apply with spatula, slightly overfilling. Clamp seams. 4) Working time: 4-5 min (gel time) min. 5) Razor scrape at gel stage. Full cure: 15 min min.15 min. Sand and polish. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Low yellowing - formulated for UV resistance.",
      "Store between 68-77F.",
      "12-month shelf life.",
      "Horizontal application only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax glaxs bb 65 epoxy adhesive for stone fabrication": {
    "why_recommend": "Tenax acrylic-resin adhesive. flowing. For fissures, laminating, repair on engineered, granite, marble, quartzite.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (100:65). 3) Apply evenly. 4) Working time: (see TDS). 5) Full cure: ~20-25 min min.",
    "warnings": [
      "Zero yellowing - UV stable.",
      "Zero VOC.",
      "Cures at any temperature including 0C.",
      "Ideal for white marble and porous stone.",
      "1-year shelf life at 65-77F.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax lustro italiano etch remover 8oz for marble and limestone": {
    "why_recommend": "Tenax etch-remover for use on marble, limestone.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "For marble and limestone etch marks only.",
      "Part of Lustro Italiano consumer stone care line."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "proseal nano premium grade quartzite stone sealer": {
    "why_recommend": "Tenax sealer protecting concrete, engineered, granite, quartzite against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours. Solvent-based. Works on polished, honed, sandblasted, flamed finishes. Does not alter natural breathability.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Incompatible with acids, bases, strong oxidants, aluminium, plastics.",
      "Solvent-based.",
      "Works on polished, honed, sandblasted, flamed finishes.",
      "Does not alter natural breathability."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax hydrex natural effect sealer for natural and engineered stone": {
    "why_recommend": "Tenax sealer protecting engineered, granite, marble, quartzite against stains and water. Apply, wait, wipe excess. Full cure 24 hours full protection.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours full protection) before use. Apply second coat if needed.",
    "warnings": [
      "Does NOT change stone color - natural effect.",
      "Water and oil proof.",
      "Does NOT provide anti-etch protection on marble.",
      "Coverage: 215-323 sq ft per liter.",
      "2-year shelf life at 65-77F."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "stain rescue remover ( formerly known as tenax quartz extraclean pro ) 1 qt": {
    "why_recommend": "Tenax stain remover for stains on engineered. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Designed to remove greasy suction cup rings from quartz slabs.",
      "Apply with cloth, leave 1-2 minutes, rub in circular motion.",
      "Coverage: 200-300 sq ft per quart."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax cera pasta clear wax paste (1 liter / 1 quart)": {
    "why_recommend": "Tenax wax for use on granite, marble, engineered. Increases polish and eliminates superficial defects. Accents stone color.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "For onyxes, marbles, agglomerates, and terrazzo.",
      "Increases polish and eliminates superficial defects.",
      "Accents stone color."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax teclean stain remover 8 oz for stone surface restoration": {
    "why_recommend": "Tenax stain remover for stains on granite, marble, engineered. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Poultice powder format - mix with water to form paste.",
      "Apply to stain, cover, let dry, then remove."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax skudo shield - quartz shield - 1 l": {
    "why_recommend": "Tenax sealer protecting engineered, granite, porcelain, quartzite against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours. Water-based formula.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Food contact approved (EC Reg 1935/2004).",
      "Repels oil and water.",
      "Safe for quartz and engineered stone.",
      "Does not form surface films.",
      "Water-based formula."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax cera black g liquid wax for black granite": {
    "why_recommend": "Tenax wax for use on granite.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "Specifically designed for black granite.",
      "Increases black effect without increasing gloss.",
      "Also known as Uniblack 2.",
      "Use after Toner Black for complete black restoration system.",
      "2-year shelf life at 65-77F."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax terust rust remover powder for stone and marble cleaning": {
    "why_recommend": "Tenax stain remover for stains on granite, marble, engineered. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Powder format - mix with water.",
      "Specifically for rust stain removal from stone."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax hydrex natural effect stone sealer for granite and marble": {
    "why_recommend": "Tenax sealer protecting engineered, granite, marble, quartzite against stains and water. Apply, wait, wipe excess. Full cure 24 hours full protection.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours full protection) before use. Apply second coat if needed.",
    "warnings": [
      "Does NOT change stone color - natural effect.",
      "Water and oil proof.",
      "Does NOT provide anti-etch protection on marble.",
      "Coverage: 215-323 sq ft per liter.",
      "2-year shelf life at 65-77F."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax teetch etch remover for marble and stone surface restoration": {
    "why_recommend": "Tenax etch-remover for use on marble, limestone.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "For marble and limestone etch marks.",
      "Part of Tenax professional stone care line."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax ager stone color enhancing sealer 1 quart": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on engineered, granite, marble, quartzite. Test first - effect is permanent. UV resistant, non-yellowing.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Does NOT provide anti-etch protection on marble.",
      "Wait 24 hours for finished surface.",
      "No foot traffic for 4-6 hours after treatment.",
      "UV resistant, non-yellowing.",
      "1 quart size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax ager tiger 1qt. (1l) exotic stone enhancer & sealer for granite - color enriching, stain protection": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on granite, marble, quartzite. Test first - effect is permanent. UV resistant, non-yellowing.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Designed for exotic stones - darkens and enriches color.",
      "Does NOT provide anti-etch protection on marble.",
      "Drying time ~1 hour.",
      "Wait 24 hours before foot traffic.",
      "Coverage: 140-323 sq ft per liter depending on porosity.",
      "UV resistant, non-yellowing."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax booster alk easy alkaline stone treatment - 750 ml": {
    "why_recommend": "Tenax stain remover for stains on engineered, granite, marble, porcelain. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Do not dilute - use as-is.",
      "Maximum contact time: 30 minutes.",
      "Removes organic stains, wax residue, food stains.",
      "May affect alkali-sensitive surfaces.",
      "750 ml spray bottle."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax wax remover for natural stone surfaces - 1 quart": {
    "why_recommend": "Tenax cleaner for granite, marble, engineered. Follow dilution instructions. Solvent-based.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Removes paste and liquid wax residue from stone surfaces.",
      "Solvent-based."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax stain rescue remover 250 ml for granite and marble care": {
    "why_recommend": "Tenax stain remover for stains on engineered. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Designed to remove greasy suction cup rings from quartz slabs.",
      "Apply with cloth, leave 1-2 minutes, rub in circular motion.",
      "250 ml size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax ager tiger exotic stone sealer 250 ml": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on granite, marble, quartzite. Test first - effect is permanent. UV resistant, non-yellowing.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Designed for exotic stones - darkens and enriches color.",
      "Does NOT provide anti-etch protection on marble.",
      "UV resistant, non-yellowing.",
      "250 ml size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax ager fs water-based sealer 250 ml food safe": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on engineered, granite, marble, quartzite. Test first - effect is permanent. Water-based - lower VOC. UV stable - does not change color in sunlight.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Food contact approved (EC Reg 90/128 ECC).",
      "Conceals small scratches on engineered stone.",
      "Water-based - lower VOC.",
      "UV stable - does not change color in sunlight.",
      "250 ml size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax luxor spray 0.5 liter aerosol varnish": {
    "why_recommend": "Tenax polishing product for restoring shine on granite, marble, engineered. UV stable - does not yellow.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [
      "Forms hard anti-scratch film on surface.",
      "Excellent for chiseled edges and underside of overhangs.",
      "Aerosol spray format - 0.5 liter.",
      "UV stable - does not yellow."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax rust remover liquid 1 liter for natural stone surfaces": {
    "why_recommend": "Tenax stain remover for stains on granite, marble, engineered. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Specifically for rust stain removal from stone.",
      "1 liter liquid format."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax lustro italiano reseal kit for natural stone surfaces": {
    "why_recommend": "Tenax sealer protecting granite, marble, engineered against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Part of Lustro Italiano consumer stone care line.",
      "Kit includes sealer and application materials."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax lustro italiano quartz stone sealer 16 fl oz": {
    "why_recommend": "Tenax sealer protecting engineered against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Designed specifically for quartz and engineered stone.",
      "Part of Lustro Italiano consumer line.",
      "16 fl oz size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax lustro italiano stain remover poultice powder 8 oz": {
    "why_recommend": "Tenax stain remover for stains on granite, marble, engineered. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Poultice powder format - mix with water to form paste.",
      "Part of Lustro Italiano consumer line.",
      "8 oz size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax concrete prowax 1 liter - protective polymer coating for cement surfaces": {
    "why_recommend": "Tenax sealer protecting concrete against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Polymer blend creates protective film in pores.",
      "For cement and cement agglomerates.",
      "Protects from organic and inorganic substances."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax cera fluida liquid stone wax 1 quart for marble & granite": {
    "why_recommend": "Tenax wax for use on granite, marble, engineered. Increases polish and eliminates superficial defects on marble. Accents stone color.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "For onyxes, marbles, agglomerates, and terrazzo.",
      "Increases polish and eliminates superficial defects on marble.",
      "Accents stone color."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "ager - the original color enhancer impregnataor sealer": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on engineered, granite, marble, quartzite. Test first - effect is permanent. UV resistant, non-yellowing.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Does NOT provide anti-etch protection on marble.",
      "Wait 24 hours for finished surface.",
      "No foot traffic for 4-6 hours after treatment.",
      "UV resistant, non-yellowing."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax hydrex polished stone sealer - 5 l": {
    "why_recommend": "Tenax sealer protecting engineered, granite, marble, quartzite against stains and water. Apply, wait, wipe excess. Full cure 24 hours full protection.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours full protection) before use. Apply second coat if needed.",
    "warnings": [
      "Does NOT change stone color - natural effect.",
      "Water and oil proof.",
      "Does NOT provide anti-etch protection on marble.",
      "5 liter bulk size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax quarzo toner plus color enhancer sealer - 1 l": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on engineered, granite, quartzite. Test first - effect is permanent. UV stable - does not change color in sunlight.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Food contact approved (EC Reg 90/128 ECC).",
      "Conceals minor scratches and imperfections.",
      "Oil and water resistance.",
      "UV stable - does not change color in sunlight.",
      "1 liter size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax marble stain and etch remover for natural stone surfaces": {
    "why_recommend": "Tenax stain remover for stains on marble, limestone. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "For marble and limestone surfaces.",
      "Addresses both stains and etch marks."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax marble rust and etch remover for natural stone surfaces": {
    "why_recommend": "Tenax stain remover for stains on marble, limestone. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "For marble and limestone surfaces.",
      "Addresses both rust stains and etch marks."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax booster concentrated stone performance enhancer - 1 liter": {
    "why_recommend": "Tenax cleaner for engineered, granite, marble, porcelain. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Concentrated formula - dilute before use.",
      "Alkaline cleaner for heavy-duty cleaning.",
      "1 liter size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax ager fs water-based color enhancing sealer - 1 quart": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on engineered, granite, marble, quartzite. Test first - effect is permanent. Water-based - lower VOC. UV stable - does not change color in sunlight.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Food contact approved (EC Reg 90/128 ECC).",
      "Conceals small scratches on engineered stone.",
      "Coverage: 215-323 sq ft.",
      "2-year shelf life at 65-77F.",
      "Water-based - lower VOC.",
      "UV stable - does not change color in sunlight."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax booster alk alkaline stain remover for natural stone surfaces": {
    "why_recommend": "Tenax cleaner for engineered, granite, marble, porcelain. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Concentrated formula - dilute before use.",
      "Alkaline degreaser.",
      "Removes organic stains, grease, wax residue."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax petrolux trans 200 lt for stone fabrication": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on granite, marble, quartzite. Test first - effect is permanent. Enhances color and adds topical polish.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Disguises superficial micro-porosities and web-cracks.",
      "Test on hidden area first.",
      "Enhances color and adds topical polish.",
      "200 liter industrial drum."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax ager 200 lt for natural stone for natural stone care": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on engineered, granite, marble, quartzite. Test first - effect is permanent. UV resistant, non-yellowing.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Does NOT provide anti-etch protection on marble.",
      "UV resistant, non-yellowing.",
      "200 liter industrial drum."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax lustro italiano stone sealer 8.5 oz": {
    "why_recommend": "Tenax sealer protecting granite, marble, engineered against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Part of Lustro Italiano consumer line.",
      "Aerosol spray with sealant.",
      "Coverage: ~120-150 sq ft per can.",
      "8.5 oz size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax toner black stone dye 1 quart - professional grade": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on granite. Test first - effect is permanent.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Very strong concentrated black dye.",
      "Designed for black granite restoration.",
      "Follow up with Cera Black G for maintenance.",
      "Store at 65-77F, 12-month shelf life."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax sealer and wax remover for natural and engineered stone": {
    "why_recommend": "Tenax cleaner for granite, marble, engineered. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Removes both sealers and waxes from stone.",
      "Use before resealing stone surfaces."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax sealer and wax remover 1 quart for natural and engineered stone": {
    "why_recommend": "Tenax cleaner for granite, marble, engineered. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Removes both sealers and waxes from stone.",
      "Use before resealing stone surfaces.",
      "1 quart size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax zero purple liquid stain remover 1 liter": {
    "why_recommend": "Tenax stain remover for stains on granite, marble. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Contains active chlorine.",
      "Apply with roller or brush, leave 30-60 minutes, rinse.",
      "Not aggressive - safe for polished surfaces.",
      "Removes existing stains and prevents new spots."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax brioaction 2 mold remover for natural stone surfaces": {
    "why_recommend": "Tenax cleaner for granite, marble, concrete, porcelain. Follow dilution instructions. Biodegradable (>90%). Non-toxic and environmentally friendly.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Removes mold, moss, algae, musk, and fungus.",
      "Also an effective sanitizer.",
      "12-month shelf life at 65-77F.",
      "Biodegradable (>90%).",
      "Non-toxic and environmentally friendly."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax booster acid extra strong 1 quart - professional grade": {
    "why_recommend": "Tenax cleaner for engineered, porcelain. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "ACID - Do NOT use on marble, limestone, or other acid-sensitive stone.",
      "Concentrated - dilute before use.",
      "For end-of-site cleaning.",
      "Removes limescale, mineral deposits, joint residues, rust traces."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax booster alk easy 200 liter - professional grade": {
    "why_recommend": "Tenax stain remover for stains on engineered, granite, marble, porcelain. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Maximum contact time: 30 minutes.",
      "Removes organic stains, wax residue, food stains.",
      "200 liter industrial drum."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax antislip m treatment 1 liter - professional grade": {
    "why_recommend": "Tenax treatment for use on marble, limestone.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "IRREVERSIBLE treatment - may reduce gloss permanently.",
      "Always test on hidden area first.",
      "Coverage: 10-15 sq meters per liter.",
      "Rinse thoroughly with clean water after treatment.",
      "2-year shelf life below 86F."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax antislip g treatment 1 liter - professional grade": {
    "why_recommend": "Tenax treatment for use on granite, porcelain.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "IRREVERSIBLE treatment - may reduce gloss permanently.",
      "Always test on hidden area first.",
      "Coverage: 10-15 sq meters per liter.",
      "Rinse thoroughly with clean water after treatment.",
      "2-year shelf life below 86F."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax skudo stone sealer 1 quart for natural and engineered stone": {
    "why_recommend": "Tenax sealer protecting engineered, granite, porcelain, quartzite against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours. Water-based formula.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Food contact approved (EC Reg 1935/2004).",
      "Repels oil and water.",
      "Does not form surface films.",
      "Water-based formula.",
      "1 quart size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax luxor wax for natural stone for natural stone finishing": {
    "why_recommend": "Tenax polishing product for restoring shine on granite, marble, engineered. UV stable - does not yellow.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [
      "Forms hard anti-scratch film on surface.",
      "Excellent for chiseled edges and areas where mechanical polishing is difficult.",
      "UV stable - does not yellow."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax concrete sealer and water repellant": {
    "why_recommend": "Tenax sealer protecting concrete against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Penetrates deep into concrete.",
      "Protects against water without altering breathability.",
      "Protects against algae and mold."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax petrolux transparent microfissure repair and polish": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on granite, marble, quartzite. Test first - effect is permanent. Enhances color and adds topical polish.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Disguises superficial micro-porosities and web-cracks on polished stone.",
      "Best on polished dark granites.",
      "Test on hidden area first.",
      "Coverage: 215-323 sq ft per liter.",
      "2-year shelf life at 65-77F.",
      "Enhances color and adds topical polish."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax ager stone enhancing sealer 55 liter keg": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on engineered, granite, marble, quartzite. Test first - effect is permanent. UV resistant, non-yellowing.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Does NOT provide anti-etch protection on marble.",
      "UV resistant, non-yellowing.",
      "55 liter industrial keg."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax terust rust remover 8 oz liquid for stone surfaces": {
    "why_recommend": "Tenax stain remover for stains on granite, marble, engineered. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Specifically for rust stain removal from stone.",
      "8 oz liquid format."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax lustro italiano stone cleaner 32 fl oz": {
    "why_recommend": "Tenax cleaner for granite, marble, engineered, porcelain. Safe for daily use.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "PH balanced - no harmful solvents.",
      "Will not shorten life of stone sealant.",
      "Safe for daily use on all stone surfaces.",
      "Also works on ceramic, porcelain, stainless steel.",
      "32 fl oz size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax lustro italiano quartz cleaner 16 fl oz": {
    "why_recommend": "Tenax cleaner for engineered. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Designed specifically for quartz and engineered stone.",
      "Part of Lustro Italiano consumer line.",
      "16 fl oz size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax quartz ax cleaner for engineered stone surfaces - 1 liter": {
    "why_recommend": "Tenax cleaner for engineered, porcelain. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Do NOT use on marble or acid-sensitive stone - will cause corrosion and opacity.",
      "Do not use with hypochlorite-containing detergents.",
      "Leave 2-3 minutes, max 30 minutes, then rinse.",
      "Removes limescale and mineral deposits.",
      "1 liter size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax lustro italiano stone care kit - professional stone care": {
    "why_recommend": "Tenax care kit for granite, marble, engineered.",
    "application_tip": "1) Read included instructions. 2) Clean surface first. 3) Apply products in order specified by kit. 4) Follow timing and application directions for each component.",
    "warnings": [
      "Kit includes 32 oz cleaner + 11 oz polish spray.",
      "Safe for granite, marble, quartz, Corian.",
      "Polish coverage: ~120-150 sq ft per 11 oz can."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax lustro italiano rust remover 8 oz for natural stone surfaces": {
    "why_recommend": "Tenax stain remover for stains on granite, marble, engineered. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Part of Lustro Italiano consumer line.",
      "Specifically for rust stains.",
      "8 oz size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax lustro italiano quartz stone care kit": {
    "why_recommend": "Tenax care kit for engineered.",
    "application_tip": "1) Read included instructions. 2) Clean surface first. 3) Apply products in order specified by kit. 4) Follow timing and application directions for each component.",
    "warnings": [
      "Designed specifically for quartz and engineered stone.",
      "Part of Lustro Italiano consumer line."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax lustro italiano quartz polish enhancer 8.5 oz": {
    "why_recommend": "Tenax polishing product for restoring shine on engineered.",
    "application_tip": "ALWAYS test on a scrap piece or inconspicuous area first. 1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth. WARNING: Color enhancement is permanent and cannot be reversed.",
    "warnings": [
      "Designed specifically for quartz and engineered stone.",
      "Aerosol spray format.",
      "Part of Lustro Italiano consumer line.",
      "8.5 oz size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax lustro italiano stone polish 11 fl oz": {
    "why_recommend": "Tenax polishing product for restoring shine on granite, marble, engineered.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [
      "Spray-on polish includes sealer for added luster.",
      "Coverage: ~120-150 sq ft per can.",
      "Part of Lustro Italiano consumer line.",
      "11 fl oz aerosol."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax teblossom and teclean stain removal kit": {
    "why_recommend": "Tenax care kit for granite, marble, engineered.",
    "application_tip": "1) Read included instructions. 2) Clean surface first. 3) Apply products in order specified by kit. 4) Follow timing and application directions for each component.",
    "warnings": [
      "Includes TeBlossom (green/blue stain remover) and TeClean (poultice powder).",
      "TeBlossom removes discoloration from chip repair processes.",
      "Does not etch stone."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax cement remover descaling agent 1 liter": {
    "why_recommend": "Tenax cleaner for engineered, porcelain. Follow dilution instructions. Water-based.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "ACID - Do NOT use on marble, limestone, or acid-sensitive stone.",
      "Does not contain hydrochloric acid.",
      "Concentrated - dilute with water.",
      "Leave max 30 minutes then rinse.",
      "Saturate surface with water before applying.",
      "Water-based."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax brioaction 3 professional stain remover": {
    "why_recommend": "Tenax cleaner for granite, marble, concrete, porcelain. Follow dilution instructions. Biodegradable (>90%). Non-toxic and environmentally friendly.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Heavy-duty cleanser for restoration and large areas.",
      "Also an effective sanitizer.",
      "12-month shelf life at 65-77F.",
      "Biodegradable (>90%).",
      "Non-toxic and environmentally friendly."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax lustro italiano stone cleaner for natural stone care": {
    "why_recommend": "Tenax cleaner for granite, marble, engineered, porcelain. Safe for daily use.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "PH balanced - no harmful solvents.",
      "Will not shorten life of stone sealant.",
      "Safe for daily use on all stone surfaces.",
      "Part of Lustro Italiano consumer line."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "strongbond cartridge glue - strong epoxy adhesive for lapitec and engineered stone": {
    "why_recommend": "Tenax epoxy (bi-component) adhesive. gel. For laminating, seaming on engineered, porcelain, sintered.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (2:1 (pre-dosed cartridge)). 3) Apply evenly. 4) Working time: (see TDS). 5) Full cure: (see TDS). Do not disturb the bond during cure.",
    "warnings": [
      "Zero yellowing - UV stable.",
      "Solvent free.",
      "Requires Tenax 2:1 cartridge gun.",
      "Specifically designed for Lapitec sintered stone."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax cd mastidek 215 ml - professional grade": {
    "why_recommend": "Tenax acrylic (bi-component color-matched) adhesive. gel. For laminating, seaming on engineered, porcelain, sintered.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (2:1 (pre-dosed cartridge)). 3) Apply evenly. 4) Working time: (see TDS). 5) Full cure: (see TDS).",
    "warnings": [
      "Zero yellowing - UV stable.",
      "Requires Tenax 2:1 cartridge gun.",
      "Color-matched for Dekton and Cosentino surfaces.",
      "215 ml cartridge."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax colored flowing polyester 1 quart - professional grade": {
    "why_recommend": "Tenax flowing polyester adhesive. Self-levels into joints. Cure , mix 100:2-3 (resin to hardener by weight). For fissures, laminating, repair, seaming on engineered, granite, marble, quartzite. Interior only. Available in multiple pre-tinted colors.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 100:2-3 (resin to hardener by weight). Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: (see TDS). Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: (see TDS). Sand from 220-grit up and polish to match. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Interior only - not UV stable.",
      "Horizontal application only due to flowing consistency.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work.",
      "Available in multiple pre-tinted colors."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax epoxart kit 3:1 epoxy system for resin coating and stone repair": {
    "why_recommend": "Tenax epoxy resining system adhesive. flowing. For resining, reinforcing, repair on granite, marble. Interior only.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (3:1 (resin to hardener)). 3) Apply evenly. 4) Working time: (see TDS). 5) Full cure: (see TDS). NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical. Do not disturb the bond during cure.",
    "warnings": [
      "For slab resining with fiberglass reinforcement.",
      "High transparency, high penetration, slow curing.",
      "Ideal for small batches.",
      "Stone must be completely dry and clean.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax fixtop a&b 1+1 liter two-part stone epoxy adhesive": {
    "why_recommend": "Tenax two-part epoxy, structural bond strength. 1:1 mix, working, full cure. For substrate-bonding, laminating, anchoring on concrete, engineered, granite, marble, porcelain. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Mix resin and hardener at 1:1. Stir 60 seconds. 3) Apply to both surfaces. Clamp firmly. 4) Working time: (see TDS). Do not disturb after. 5) Full cure: (see TDS). Sand from 220-grit up and polish.",
    "warnings": [
      "100% epoxy - not water-based.",
      "Does not dissolve or break down in water.",
      "Suitable for shower applications.",
      "VOC compliant.",
      "1+1 liter kit.",
      "Long cure time compared to polyester adhesives."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax fixtop and fixdeck epoxy parts for stone and porcelain bonding": {
    "why_recommend": "Tenax two-part epoxy, structural bond strength. 1:1 mix, working, full cure. For substrate-bonding, laminating, anchoring on concrete, engineered, granite, marble, porcelain. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Mix resin and hardener at 1:1. Stir 60 seconds. 3) Apply to both surfaces. Clamp firmly. 4) Working time: (see TDS). Do not disturb after. 5) Full cure: (see TDS). Sand from 220-grit up and polish.",
    "warnings": [
      "100% epoxy - not water-based.",
      "Does not dissolve or break down in water.",
      "Suitable for shower applications.",
      "VOC compliant.",
      "Long cure time compared to polyester adhesives."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax fixtop fixdeck a+b slow curing tile and stone epoxy": {
    "why_recommend": "Tenax two-part epoxy, structural bond strength. 1:1 mix, 90 min (gel time at 77F) working, tack-free ~4 hours full cure. For substrate-bonding on concrete, engineered, granite, marble, porcelain. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Mix resin and hardener at 1:1. Stir 60 seconds. 3) Apply to both surfaces. Clamp firmly. 4) Working time: 90 min (gel time at 77F) min. Do not disturb after. 5) Full cure: tack-free ~4 hours min.tack-free ~4 hours. Sand from 220-grit up and polish.",
    "warnings": [
      "Slow-cure formula for extended working time.",
      "Water-resistant - suitable for outdoor/shower use.",
      "Apply in thin layers.",
      "Service temp range: -13 to 143F after cure.",
      "Long cure time compared to polyester adhesives."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax glaxs color match cartridge adhesive 215 ml": {
    "why_recommend": "Tenax acrylic adhesive for penetrating repair and filling. gel. Cure ~15-25 min, mix 2:1 (pre-dosed cartridge). For laminating, mitering, repair, seaming on engineered, granite, marble, porcelain, quartzite.",
    "application_tip": "1) Ensure surface is clean and dry. 2) Mix resin with hardener at 2:1 (pre-dosed cartridge). 3) Apply or pour into cracks/voids. 4) Working time: 3-5 min (gel time at 77F) min. 5) Cure: ~15-25 min. Sand flush and polish.",
    "warnings": [
      "Zero VOC.",
      "Zero yellowing.",
      "Requires Tenax 2:1 cartridge gun.",
      "Cures down to 34F.",
      "12-month shelf life at 65-77F.",
      "Service temp: -13 to 140F."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax glaxs easy tube epoxy adhesive for granite and marble": {
    "why_recommend": "Tenax acrylic-resin adhesive. flowing. For fissures, laminating, repair on engineered, granite, marble, quartzite.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (). 3) Apply evenly. 4) Working time: (see TDS). 5) Full cure: ~20-25 min min.",
    "warnings": [
      "Zero yellowing - 15-year guarantee.",
      "Solvent free, low viscosity, odorless.",
      "Cure time not affected by temperature.",
      "Easy squeeze-tube format - no gun needed.",
      "Good for pitholes and slab filling.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax glaxs ultra fast transparent chip repair 50 ml": {
    "why_recommend": "Tenax acrylic chip repair adhesive. flowing. For repair on engineered, granite, marble, porcelain.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (2:1 (pre-dosed cartridge)). 3) Apply evenly. 4) Working time: ~1 min (gel time at 77F) min. 5) Full cure: tack-free ~4 min min.tack-free ~4 min.",
    "warnings": [
      "Ultra-fast curing - 1 minute gel time.",
      "Zero yellowing - UV stable.",
      "Zero VOC.",
      "Requires 2:1 ratio cartridge gun.",
      "Cures at low temperatures (down to 1C).",
      "Runs on vertical surfaces - use knife-grade for vertical work.",
      "50 ml size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax micto two-part protective coating system for stone - 2 liter kit": {
    "why_recommend": "Tenax two-part epoxy, structural bond strength. 1:1 mix, working, ~15 min full cure. For repair, fissures, rodding on engineered, granite, marble, quartzite.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Mix resin and hardener at 1:1. Stir 60 seconds. 3) Apply to both surfaces. Clamp firmly. 4) Working time: (see TDS). Do not disturb after. 5) Full cure: ~15 min min. Sand from 220-grit up and polish. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Will yellow when exposed to sunlight (use in non-visible areas outdoors).",
      "VOC compliant.",
      "2-year shelf life at 65-77F.",
      "Runs on vertical surfaces - use knife-grade for vertical work.",
      "Long cure time compared to polyester adhesives.",
      "2 liter kit."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax polishing powder 33 pound (15 kg) for natural stone": {
    "why_recommend": "Tenax polishing-compound for use on granite, marble.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "Apply 30-60g per sq meter with buffing machine and felt pad.",
      "Add water to create milky consistency.",
      "For countertops, floors, and general maintenance.",
      "33 lb (15 kg) bulk size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax poxart kit 2:1 epoxy system for resin coating and stone repair": {
    "why_recommend": "Tenax epoxy resining system adhesive. flowing. For resining, reinforcing, repair on granite, marble. Interior only.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (2:1 (resin to hardener)). 3) Apply evenly. 4) Working time: (see TDS). 5) Full cure: (see TDS). NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical. Do not disturb the bond during cure.",
    "warnings": [
      "For slab resining with fiberglass reinforcement.",
      "High penetration.",
      "Stone must be completely dry and clean.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax poxart kit 4:1 epoxy system for resin coating and stone repair": {
    "why_recommend": "Tenax epoxy resining system adhesive. flowing. For resining, reinforcing, repair on granite, marble. Interior only.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (4:1 (resin to hardener)). 3) Apply evenly. 4) Working time: (see TDS). 5) Full cure: (see TDS). NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical. Do not disturb the bond during cure.",
    "warnings": [
      "For slab resining with fiberglass reinforcement.",
      "Highest dilution ratio - most penetration, slowest cure.",
      "Stone must be completely dry and clean.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax rivo a&b 1+1 liter two-part stone bonding epoxy": {
    "why_recommend": "Tenax two-part epoxy, structural bond strength. 1:1 mix, 15 min (gel time) working, ~90 min full cure. For anchoring, laminating, repair, seaming, substrate-bonding on concrete, engineered, granite, marble, porcelain. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Mix resin and hardener at 1:1. Stir 60 seconds. 3) Apply to both surfaces. Clamp firmly. 4) Working time: 15 min (gel time) min. Do not disturb after. 5) Full cure: ~90 min min.~90 min. Sand from 220-grit up and polish.",
    "warnings": [
      "VOC compliant.",
      "Bonds to nearly any surface.",
      "1+1 liter kit.",
      "Long cure time compared to polyester adhesives."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax semisolido wet buff semi-solid polish for granite marble - 4 liter": {
    "why_recommend": "Tenax polishing product for restoring shine on granite, marble.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [
      "For wet buffing/polishing stone surfaces.",
      "Apply with buffing machine and felt pad.",
      "4 liter container."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax tixo extra knife grade transparent": {
    "why_recommend": "Tenax knife-grade polyester adhesive. Stays in place on vertical surfaces. Cure , mix 100:2-3 (resin to hardener by weight). For fissures, laminating, repair, seaming on engineered, granite, marble. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 100:2-3 (resin to hardener by weight). Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: (see TDS). Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: (see TDS). Sand from 220-grit up and polish to match.",
    "warnings": [
      "Interior only - not UV stable.",
      "May yellow on light-colored marble over time."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax tixo x prism polyester knife grade adhesive for granite and marble": {
    "why_recommend": "Tenax knife-grade polyester adhesive. Stays in place on vertical surfaces. Cure , mix 100:2-3 (resin to hardener by weight). For fissures, laminating, repair, seaming on engineered, granite, marble. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 100:2-3 (resin to hardener by weight). Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: (see TDS). Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: (see TDS). Sand from 220-grit up and polish to match.",
    "warnings": [
      "Interior only - not UV stable.",
      "May yellow on light-colored marble over time."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax transparent flowing polyester - professional grade": {
    "why_recommend": "Tenax flowing polyester adhesive. Self-levels into joints. Cure , mix 100:2-3 (resin to hardener by weight). For fissures, laminating, repair, seaming on engineered, granite, marble, quartzite. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 100:2-3 (resin to hardener by weight). Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: (see TDS). Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: (see TDS). Sand from 220-grit up and polish to match. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Interior only - not UV stable.",
      "Horizontal application only due to flowing consistency.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax transparent knife grade h - professional grade": {
    "why_recommend": "Tenax knife-grade polyester adhesive. Stays in place on vertical surfaces. Cure , mix 100:2-3 (resin to hardener by weight). For fissures, laminating, repair, seaming on engineered, granite, marble. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 100:2-3 (resin to hardener by weight). Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: (see TDS). Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: (see TDS). Sand from 220-grit up and polish to match.",
    "warnings": [
      "Interior only - not UV stable.",
      "Requires Tenax hardener.",
      "May yellow on light-colored marble over time."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax ultra-fast epoxy plus cartridge glue 210 ml": {
    "why_recommend": "Tenax two-part epoxy, structural bond strength. 2:1 (pre-dosed cartridge) mix, working, full cure. For laminating, repair, seaming on engineered, granite, marble, porcelain.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Mix resin and hardener at 2:1 (pre-dosed cartridge). Stir 60 seconds. 3) Apply to both surfaces. Clamp firmly. 4) Working time: (see TDS). Do not disturb after. 5) Full cure: (see TDS). Sand from 220-grit up and polish.",
    "warnings": [
      "Ultra-fast curing.",
      "Requires Tenax 2:1 cartridge gun.",
      "Long cure time compared to polyester adhesives.",
      "210 ml cartridge."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax vertigo s vinyl ester knife grade - 1 gallon": {
    "why_recommend": "Tenax vinyl-ester with low yellowing, superior color stability. knife-grade, cure 25 min. For fissures, laminating, mitering, repair, seaming on engineered, granite, marble, porcelain, quartzite, sintered. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Mix resin with catalyst at 100:2-3 (resin to catalyst by weight). Stir thoroughly. 3) Apply with spatula, slightly overfilling. Clamp seams. 4) Working time: 4-5 min (gel time) min. 5) Razor scrape at gel stage. Full cure: 25 min min.25 min. Sand and polish.",
    "warnings": [
      "Low yellowing - formulated for UV resistance.",
      "Drip-less formula.",
      "1 gallon size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax vertigo t vinyl ester knife grade - professional grade": {
    "why_recommend": "Tenax vinyl-ester with low yellowing, superior color stability. knife-grade, cure 20 min. For fissures, laminating, mitering, repair, seaming on engineered, granite, marble, porcelain, quartzite, sintered. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Mix resin with catalyst at 100:2-3 (resin to catalyst by weight). Stir thoroughly. 3) Apply with spatula, slightly overfilling. Clamp seams. 4) Working time: 4-5 min (gel time) min. 5) Razor scrape at gel stage. Full cure: 20 min min.20 min. Sand and polish.",
    "warnings": [
      "Low yellowing - formulated for UV resistance.",
      "Thicker consistency than Vertigo S."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax shinex liquid silicone wax 1 liter": {
    "why_recommend": "Tenax wax for use on granite, marble, engineered.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "Intensifies original tone of stone.",
      "Reduces stains and fingerprint visibility.",
      "Silky smooth finish with excellent gloss.",
      "For polished surfaces."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax teblossom green blossom stain removal kit": {
    "why_recommend": "Tenax stain remover for stains on granite, marble, engineered. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Removes green/blue stains caused by chip repair kits.",
      "Two-part poultice process.",
      "Does not etch stone."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax ager pen 6-piece stone scratch concealer & color enhancer set": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on engineered, granite, marble. Test first - effect is permanent.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Pen format for precision scratch concealment.",
      "Color enhancing.",
      "Set of 6 pens."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax titanium kg stone sealer & color enhancer - 1 qt": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on engineered, granite, marble, quartzite. Test first - effect is permanent. UV resistant.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Color enriching stone enhancer and sealer.",
      "UV resistant.",
      "1 quart size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax water ager water-based color enhancing sealer - 1 liter": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on engineered, granite, marble, quartzite. Test first - effect is permanent. Water-based formula - lower VOC than solvent-based Ager.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Color enhancing with sealing properties.",
      "Water-based formula - lower VOC than solvent-based Ager.",
      "1 liter size."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax pectro black 1 quart dark stone micro fissure & webbing concealer": {
    "why_recommend": "Tenax color enhancer deepening natural stone color and veining on granite. Test first - effect is permanent. UV resistant for outdoor use.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "For dark granites only (black, brown, green).",
      "Hides micro fissures and webbing.",
      "Immediately buff with clean cloth after application.",
      "2-year shelf life at 65-77F.",
      "UV resistant for outdoor use."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax universal stone chip repair kit - professional stone care": {
    "why_recommend": "Tenax care kit for engineered, granite, marble.",
    "application_tip": "1) Read included instructions. 2) Clean surface first. 3) Apply products in order specified by kit. 4) Follow timing and application directions for each component.",
    "warnings": [
      "Kit includes repair components for various chip sizes.",
      "For scratches, chips, and blemishes on stone."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax tefill chip repair components - professional grade": {
    "why_recommend": "Tenax chip-repair for use on engineered, granite, marble.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "TeFill 1: for fissures and scratches on horizontal surfaces.",
      "TeFill 2: for larger chips on horizontal and vertical surfaces.",
      "TeFill 3: activator creates chemical reaction.",
      "Dries in under a minute with polished look."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax granite polishing powder 2 lb (1 kg)": {
    "why_recommend": "Tenax polishing-compound for use on granite.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "Apply 30-60g per sq meter with buffing machine and felt pad.",
      "Add water to create milky consistency.",
      "For countertops, floors, and general maintenance.",
      "2 lb (1 kg) container."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "tenax marble polishing powder 2 lb (1 kg)": {
    "why_recommend": "Tenax polishing-compound for use on marble.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "Apply 30-60g per sq meter with buffing machine and felt pad.",
      "Add water to create milky consistency.",
      "For countertops, floors, and general maintenance.",
      "2 lb (1 kg) container."
    ],
    "source_urls": [
      "https://www.tenaxusa.com"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi akenova lion grip 50 (cc 1100 white) - 290 ml cartridge": {
    "why_recommend": "Akemi polyhybrid adhesive for heavy-duty bonding. paste. For substrate-bonding, anchoring, mounting on natural stone, granite, marble, ceramic, metal, wood, glass, concrete. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces thoroughly. 2) Apply adhesive from cartridge. 3) Press surfaces together firmly. 4) Allow full cure: 24 hours full cure. 5) Clean excess before curing. Do not disturb the bond during cure.",
    "warnings": [
      "For professional use only."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi marble filler super 1 kg. - highly liquid acrylic adhesive": {
    "why_recommend": "Akemi acrylic adhesive for penetrating repair and filling. highly liquid / super flowing. Cure 20-50 minutes at 68 degrees F, mix resin + 1-4% BPO hardener. For filling, strengthening, resinating, penetrating repair on natural stone, marble, granite, limestone. Interior only.",
    "application_tip": "1) Ensure surface is clean and dry. 2) Mix resin with hardener at resin + 1-4% BPO hardener. 3) Apply or pour into cracks/voids. 4) Working time: 5-10 minutes at 68 degrees F min. 5) Cure: 20-50 minutes at 68 degrees F. Sand flush and polish.",
    "warnings": [
      "Interior use only.",
      "For professional use only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi marble filler 1000 transparent l-special waterclear - quart": {
    "why_recommend": "Akemi filler for chips, holes, voids in natural stone, marble, granite. flowing. Mix with hardener, apply, cure, sand flush.",
    "application_tip": "1) Clean area and remove loose material. 2) Mix filler with hardener at resin + 1-4% BPO hardener. 3) Press into void, slightly overfilling. 4) Working time: 5-10 minutes at 68 degrees F (20 degrees C) min. 5) Cure: 20-50 minutes at 68 degrees F (20 degrees C). Sand flush from 220-grit up and polish. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Interior use only.",
      "Less BPO hardener needed in hot temperatures.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi marble filler 1000 transparent l-special 1 kg. - knife-grade polyester adhesive": {
    "why_recommend": "Akemi filler for chips, holes, voids in natural stone, marble, granite, limestone, thassos, carrara, onyx, palisandro, estremoz. knife-grade. Mix with hardener, apply, cure, sand flush. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean area and remove loose material. 2) Mix filler with hardener at resin + 2-4% BPO hardener by weight. 3) Press into void, slightly overfilling. 4) Working time: 4-6 minutes at 70 degrees F (20 degrees C) min. 5) Cure: 20-30 minutes at 70 degrees F (20 degrees C). Sand flush from 220-grit up and polish.",
    "warnings": [
      "Interior use only.",
      "Less BPO hardener needed in extremely hot temperatures.",
      "May yellow on light-colored marble over time."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi acrylic penetrant 900 ml - deep penetrating adhesive for marble repair": {
    "why_recommend": "Akemi acrylic adhesive for penetrating repair and filling. highly liquid / penetrating. Cure 20-50 minutes at 68 degrees F, mix resin + 1-4% BPO hardener. For filling, strengthening, resinating, penetrating repair on natural stone, marble, granite, limestone. Interior only.",
    "application_tip": "1) Ensure surface is clean and dry. 2) Mix resin with hardener at resin + 1-4% BPO hardener. 3) Apply or pour into cracks/voids. 4) Working time: 5-10 minutes at 68 degrees F min. 5) Cure: 20-50 minutes at 68 degrees F. Sand flush and polish.",
    "warnings": [
      "Interior use only.",
      "For professional use only."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi platinum 5.0 p+ epoxyacrylate knife grade 4500 ml - large format adhesive": {
    "why_recommend": "Akemi epoxyacrylate adhesive. knife-grade. For seaming, laminating, repair, large format bonding on natural stone, granite, marble, engineered, quartz, porcelain, sintered. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (). 3) Apply evenly. 4) Working time: 30-90 min. 5) Full cure: 2-24 hours. Do not disturb the bond during cure.",
    "warnings": [
      "For professional use only."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi everclear 505 flowing uv resistant urethane adhesive 2 liter 1900g": {
    "why_recommend": "Akemi filler for chips, holes, voids in natural stone, marble, granite, engineered. flowing. Mix with hardener, apply, cure, sand flush.",
    "application_tip": "1) Clean area and remove loose material. 2) Mix filler with hardener at . 3) Press into void, slightly overfilling. 4) Working time: 30-45 min. 5) Cure: . Sand flush from 220-grit up and polish.",
    "warnings": [
      "For professional use only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi akenova crystal clear adhesive sealant 290 ml - paintable sink adhesive": {
    "why_recommend": "Akemi polyhybrid adhesive for heavy-duty bonding. paste. For sink mounting, substrate-bonding, sealing on natural stone, granite, marble, ceramic, stainless steel, engineered. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces thoroughly. 2) Apply adhesive from cartridge. 3) Press surfaces together firmly. 4) Allow full cure: 24 hours full cure. 5) Clean excess before curing. Do not disturb the bond during cure.",
    "warnings": [
      "For professional use only."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akenova clear 300 cc 2200 290ml cartridge": {
    "why_recommend": "Akemi polyhybrid adhesive for heavy-duty bonding. paste. For sink mounting, substrate-bonding, sealing on natural stone, granite, marble, ceramic, stainless steel, engineered. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces thoroughly. 2) Apply adhesive from cartridge. 3) Press surfaces together firmly. 4) Allow full cure: 24 hours full cure. 5) Clean excess before curing. Do not disturb the bond during cure.",
    "warnings": [
      "For professional use only."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akenova elastic 100 grey 1830 290ml cartridge": {
    "why_recommend": "Akemi polyhybrid adhesive for heavy-duty bonding. paste. For sealing, substrate-bonding, flexible joints on natural stone, granite, marble, ceramic, metal, wood, glass. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces thoroughly. 2) Apply adhesive from cartridge. 3) Press surfaces together firmly. 4) Allow full cure: 24 hours full cure. 5) Clean excess before curing. Do not disturb the bond during cure.",
    "warnings": [
      "For professional use only."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akenova rocket 200 white 1130 290ml cartridge": {
    "why_recommend": "Akemi polyhybrid adhesive for heavy-duty bonding. paste. For fast bonding, substrate-bonding, mounting on natural stone, granite, marble, ceramic, metal, wood, glass. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces thoroughly. 2) Apply adhesive from cartridge. 3) Press surfaces together firmly. 4) Allow full cure: fast initial tack, 24 hours full cure. 5) Clean excess before curing. Do not disturb the bond during cure.",
    "warnings": [
      "For professional use only."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi white cc 1130 two-component stone adhesive cartridge 400 ml": {
    "why_recommend": "Akemi epoxy (two-component cartridge) adhesive. knife-grade. For seaming, laminating, repair, mitering on natural stone, granite, marble, engineered. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (auto-metered dual cartridge). 3) Apply evenly. 4) Working time: (see TDS). 5) Full cure: (see TDS). Do not disturb the bond during cure.",
    "warnings": [
      "Requires mixing nozzle.",
      "For professional use only."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi triple effect 500 ml - food-safe stone care and impregnation spray": {
    "why_recommend": "Akemi sealer protecting natural stone, granite, marble, engineered against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Shake well before use."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "afin acryclean 500ml solvent-based ready-to-use silicone remover for natural stone": {
    "why_recommend": "Akemi (Afin sub-brand) cleaner for natural stone, granite, marble. Follow dilution instructions. Solvent-based - ensure ventilation.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Test on inconspicuous area first.",
      "Solvent-based - ensure ventilation."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi natural stone basic cleaner 500 ml - food-safe alkaline cleaning agent": {
    "why_recommend": "Akemi cleaner for natural stone, granite, marble, limestone. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi rust remover 1l - acidic cleaning agent": {
    "why_recommend": "Akemi cleaner for granite, sandstone, acid resistant natural stone. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Do NOT use on acid-sensitive stones (marble, limestone, travertine).",
      "For professional use only."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi good-bye stain 500 ml - alcaline cleaning agent": {
    "why_recommend": "Akemi cleaner for natural stone, granite, marble, engineered. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi transformer 500 ml - premium protection and colour intensification sealer": {
    "why_recommend": "Akemi color enhancer deepening natural stone color and veining on natural stone, granite, marble, limestone, terrazzo, concrete ashlar, quartz. Test first - effect is permanent. Solvent-based impregnation sealer.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Ground shipping only.",
      "Solvent-based impregnation sealer."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi quartz clean & care 500 ml - food-safe daily quartz cleaning agent": {
    "why_recommend": "Akemi cleaner for quartz, engineered. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi stone sealer mat finish 1l - acrylic sealer": {
    "why_recommend": "Akemi sealer protecting natural stone, granite, marble, limestone, sandstone against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "For professional use only."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi quartz polish 250 ml - food-safe quartz care product": {
    "why_recommend": "Akemi cleaner for quartz, engineered. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi rust remover marble 1l - alkaline cleaning agent": {
    "why_recommend": "Akemi cleaner for limestone, travertine, calcite based natural stone. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Safe for acid-sensitive stones unlike standard rust remover."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi stone cleaner 1l - concentrated alkaline cleaning agent": {
    "why_recommend": "Akemi cleaner for natural stone, granite, marble, limestone. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi crystal clean 500 ml - food-safe daily cleaning agent": {
    "why_recommend": "Akemi cleaner for natural stone, granite, marble, engineered. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi oil and grease remover paste 250 ml": {
    "why_recommend": "Akemi cleaner for natural stone, granite, marble, engineered. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Apply paste, cover, let draw out stain, remove after drying."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi darkener plus 1l - colour-intensifying sealer": {
    "why_recommend": "Akemi color enhancer deepening natural stone color and veining on natural stone, marble, limestone, granite, terrazzo, slate, concrete ashlar, cotto. Test first - effect is permanent. Solvent-based product.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Solvent-based product."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi impregnation remover 1l - alkaline cleaning agent": {
    "why_recommend": "Akemi cleaner for natural stone, granite, marble. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Removes existing impregnation/sealer - reapply sealer after use."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi stone impregnation sealer for granite & natural stone": {
    "why_recommend": "Akemi sealer protecting granite, natural stone, marble, sandstone, limestone against stains and water. Apply, wait, wipe excess. Full cure fully effective after 2-3 hours; initial protection in 10-20 minutes at 20 degrees C.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (fully effective after 2-3 hours; initial protection in 10-20 minutes at 20 degrees C) before use. Apply second coat if needed.",
    "warnings": [
      "Stone must be totally dry before application (1-2 days minimum)."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi transformer quartz 1000 ml - color enhancer for quartz": {
    "why_recommend": "Akemi color enhancer deepening natural stone color and veining on quartz, engineered. Test first - effect is permanent.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Designed specifically for engineered quartz surfaces."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi lettering color 400 ml - monument paint including metallic options": {
    "why_recommend": "Akemi paint for use on natural stone, granite, marble.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi lettering color 100 ml - monument and memorial stone paint": {
    "why_recommend": "Akemi paint for use on natural stone, granite, marble.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi triple effect 250 ml spray - 3-in-1 stone cleaner, sealer, and polish": {
    "why_recommend": "Akemi sealer protecting natural stone, granite, marble, engineered against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Shake well before use."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi liqui polish universal 650 ml - liquid polishing compound": {
    "why_recommend": "Akemi polishing product for restoring shine on natural stone, granite, marble, engineered.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [
      "For professional use only."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi stone polish wax based 1 liter - natural wax polish for stone surfaces": {
    "why_recommend": "Akemi polishing product for restoring shine on natural stone, granite, marble.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi small care set - stone cleaning and maintenance starter kit": {
    "why_recommend": "Akemi care kit for natural stone, granite, marble.",
    "application_tip": "1) Read included instructions. 2) Clean surface first. 3) Apply products in order specified by kit. 4) Follow timing and application directions for each component.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi quartz care set - engineered quartz cleaning and maintenance kit": {
    "why_recommend": "Akemi care kit for quartz, engineered.",
    "application_tip": "1) Read included instructions. 2) Clean surface first. 3) Apply products in order specified by kit. 4) Follow timing and application directions for each component.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi antigraffiti protective coating - special order": {
    "why_recommend": "Akemi sealer protecting natural stone, granite, marble, concrete against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Special order item - longer lead time."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi pearl fast curing impregnator - stain blocker for quartzite": {
    "why_recommend": "Akemi sealer protecting quartzite, natural stone, granite against stains and water. Apply, wait, wipe excess. Full cure fast curing.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (fast curing) before use. Apply second coat if needed.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi transformer quartz enhancer and sealer for engineered quartz": {
    "why_recommend": "Akemi color enhancer deepening natural stone color and veining on quartz, engineered. Test first - effect is permanent.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Designed specifically for engineered quartz surfaces."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi transformer exotic enhancer impregnator - for exotic stones": {
    "why_recommend": "Akemi color enhancer deepening natural stone color and veining on exotic natural stone, quartzite, granite, marble. Test first - effect is permanent. Solvent-based product.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "For exotic stones with high absorption.",
      "Solvent-based product."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi transformer enhancer and impregnator - color enhancing sealer": {
    "why_recommend": "Akemi color enhancer deepening natural stone color and veining on natural stone, granite, marble, limestone, terrazzo, concrete ashlar, quartz. Test first - effect is permanent. Solvent-based impregnation sealer.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Ground shipping only.",
      "Solvent-based impregnation sealer."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi marble rust remover 500 ml - safe rust stain removal for marble": {
    "why_recommend": "Akemi cleaner for limestone, travertine, calcite based natural stone. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Safe for acid-sensitive stones."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi marble rust remover 1000 ml - professional rust stain removal for marble": {
    "why_recommend": "Akemi cleaner for limestone, travertine, calcite based natural stone. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Safe for acid-sensitive stones."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi rust remover paste 1l - acidic cleaning paste": {
    "why_recommend": "Akemi cleaner for granite, sandstone, acid resistant natural stone. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Do NOT use on acid-sensitive stones (marble, limestone, travertine).",
      "Paste form for vertical application."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi spider 1000 ml - flexible stone joint sealer and enhancer": {
    "why_recommend": "Akemi sealer protecting natural stone, granite, marble against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi wax stripper 1 liter - wax and coating remover for stone": {
    "why_recommend": "Akemi cleaner for natural stone, granite, marble. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Removes protective wax coatings - reapply sealer after use."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi algae and mildew remover longlife 1 liter - extended protection": {
    "why_recommend": "Akemi cleaner for natural stone, granite, marble, concrete, brick. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Extended protection formula - prevents regrowth."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi algae and mildew remover power 1 liter - fast-acting outdoor cleaner": {
    "why_recommend": "Akemi cleaner for natural stone, granite, marble, concrete, brick. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Fast-acting formula for immediate results."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi wax stripper 1 liter - professional wax and coating remover for stone": {
    "why_recommend": "Akemi cleaner for natural stone, granite, marble. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Removes protective wax coatings - reapply sealer after use."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi graffiti remover 1 liter - paint and graffiti cleaner for stone": {
    "why_recommend": "Akemi cleaner for natural stone, granite, marble, concrete. Follow dilution instructions. Solvent-based - ensure ventilation.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Test on inconspicuous area first.",
      "Solvent-based - ensure ventilation."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi algae and mildew remover longlife 1 liter - long-lasting protection": {
    "why_recommend": "Akemi cleaner for natural stone, granite, marble, concrete, brick. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Extended protection formula - prevents regrowth."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi quartz intensive cleaner and stain remover 250 ml for engineered stone": {
    "why_recommend": "Akemi cleaner for quartz, engineered. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi epoxy remover 1000 ml - professional epoxy residue cleaner for stone": {
    "why_recommend": "Akemi cleaner for natural stone, granite, marble. Follow dilution instructions. Solvent-based - ensure ventilation.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Test on inconspicuous area first.",
      "Solvent-based - ensure ventilation."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi transformer exotic 500 ml - premium protection and colour intensification sealer for exotic stones": {
    "why_recommend": "Akemi color enhancer deepening natural stone color and veining on exotic natural stone, quartzite, granite, marble. Test first - effect is permanent. Solvent-based product.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "For exotic stones with high absorption.",
      "Solvent-based product."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi everclear 510 knife-grade - quart": {
    "why_recommend": "Akemi polyurethane adhesive. gel / knife-grade. For seaming, repair on natural stone, granite, marble, engineered.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (). 3) Apply evenly. 4) Working time: 10 minutes min. 5) Full cure: (see TDS).",
    "warnings": [
      "For professional use only."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi solid wax transparent 750 ml - clear protective stone wax": {
    "why_recommend": "Akemi polishing product for restoring shine on natural stone, granite, marble.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "akemi hyperclear 1 kg. - ultra strong 2-component clear urethane adhesive": {
    "why_recommend": "Akemi polyurethane (two-component) adhesive. flowing to gel. For seaming, laminating, repair, bonding on natural stone, granite, marble, engineered.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (). 3) Apply evenly. 4) Working time: 30-45 min. 5) Full cure: 24 hours.",
    "warnings": [
      "Two-component system - mix per instructions.",
      "For professional use only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://stein.akemi.de"
    ],
    "last_verified": "2026-04-06"
  },
  "superior gold acrylic vinyl ester knife grade adhesives": {
    "why_recommend": "Superior Stone Products acrylic vinyl ester adhesive. knife-grade. For seaming, mitering, laminating, rodding, chip repair on natural stone, engineered, granite, marble. Suitable for vertical and horizontal applications. Interior only.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (1%-2% BPO hardener by weight). 3) Apply evenly. 4) Working time: 4-6 minutes @ 70 degrees F min. 5) Full cure: 20-25 minutes @ 70 degrees F min.20-25 minutes @ 70 degrees F.",
    "warnings": [
      "Indoor use only."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior polyester transparent knife grade adhesives": {
    "why_recommend": "Superior Stone Products knife-grade polyester adhesive. Stays in place on vertical surfaces. Cure 20-30 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For seaming, laminating, filling, repair on natural stone, granite, marble, limestone. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 1-4% BPO hardener by weight. Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: 4-6 minutes @ 70 degrees F min. Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. Sand from 220-grit up and polish to match.",
    "warnings": [
      "Indoor use only.",
      "May yellow on light-colored marble over time."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior ice instant color enhancement for natural stone": {
    "why_recommend": "Superior Stone Products color enhancer deepening natural stone color and veining on natural stone, granite, marble, limestone. Test first - effect is permanent.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "For natural stone only - not engineered stone."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior pearl ehc thicker knife grade adhesives": {
    "why_recommend": "Superior Stone Products thick knife-grade polyester adhesive. Stays in place on vertical surfaces. Cure 20-30 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For seaming, laminating, mitering, repair on natural stone, marble, granite, limestone. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 1-4% BPO hardener by weight. Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: 4-6 minutes @ 70 degrees F min. Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. Sand from 220-grit up and polish to match.",
    "warnings": [
      "Indoor use only.",
      "Extra thick - ideal for vertical applications.",
      "May yellow on light-colored marble over time."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior v-max premium vinyl ester sv-9 adhesives": {
    "why_recommend": "Superior Stone Products vinyl ester adhesive. thick knife-grade (SV-9). For seaming, mitering, laminating, outdoor fabrication on natural stone, engineered, granite, marble. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (1%-2% BPO hardener by weight). 3) Apply evenly. 4) Working time: 4-6 minutes @ 70 degrees F min. 5) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F.",
    "warnings": [
      "Suitable for exterior use."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior bronze polyester flowing adhesives": {
    "why_recommend": "Superior Stone Products flowing polyester adhesive. Self-levels into joints. Cure 20-30 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For laminating, filling, repair on natural stone, granite, marble. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 1-4% BPO hardener by weight. Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: 4-6 minutes @ 70 degrees F min. Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. Sand from 220-grit up and polish to match. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Indoor use only.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior bronze polyester knife grade adhesives": {
    "why_recommend": "Superior Stone Products knife-grade polyester adhesive. Stays in place on vertical surfaces. Cure 20-30 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For seaming, laminating, filling, repair on natural stone, granite, marble. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 1-4% BPO hardener by weight. Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: 4-6 minutes @ 70 degrees F min. Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. Sand from 220-grit up and polish to match.",
    "warnings": [
      "Indoor use only.",
      "May yellow on light-colored marble over time."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior polyester white knife grade adhesives": {
    "why_recommend": "Superior Stone Products knife-grade polyester adhesive. Stays in place on vertical surfaces. Cure 20-30 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For seaming, laminating, filling, repair on natural stone, granite, marble. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 1-4% BPO hardener by weight. Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: 4-6 minutes @ 70 degrees F min. Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. Sand from 220-grit up and polish to match.",
    "warnings": [
      "Indoor use only.",
      "Pre-colored white - not transparent.",
      "May yellow on light-colored marble over time."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior fire instant color enhancement for exotic natural stone": {
    "why_recommend": "Superior Stone Products color enhancer deepening natural stone color and veining on exotic natural stone, quartzite, granite. Test first - effect is permanent.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "For exotic natural stone only."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior acrylic super flowing adhesive - special order": {
    "why_recommend": "Superior Stone Products acrylic adhesive for penetrating repair and filling. super flowing (very low viscosity). Cure 20-50 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For penetrating repair, resinating, filling fissures on natural stone, marble, granite. Interior only.",
    "application_tip": "1) Ensure surface is clean and dry. 2) Mix resin with hardener at 1-4% BPO hardener by weight. 3) Apply or pour into cracks/voids. 4) Working time: 5-10 minutes @ 70 degrees F min. 5) Cure: 20-50 minutes @ 70 degrees F. Sand flush and polish.",
    "warnings": [
      "Special order item - longer lead time.",
      "Indoor use only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior acrylic quickset flowing adhesives - special order": {
    "why_recommend": "Superior Stone Products acrylic adhesive for penetrating repair and filling. flowing. Cure fast (quickset formula), mix 1-4% BPO hardener by weight. For penetrating repair, resinating, quick repairs on natural stone, marble, granite. Interior only.",
    "application_tip": "1) Ensure surface is clean and dry. 2) Mix resin with hardener at 1-4% BPO hardener by weight. 3) Apply or pour into cracks/voids. 4) Working time: (see TDS). 5) Cure: fast (quickset formula). Sand flush and polish.",
    "warnings": [
      "Special order item - longer lead time.",
      "Indoor use only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior gold evolution installation kit": {
    "why_recommend": "Superior Stone Products care kit for porcelain, sintered, quartz, dense granite, natural stone, engineered.",
    "application_tip": "1) Read included instructions. 2) Clean surface first. 3) Apply products in order specified by kit. 4) Follow timing and application directions for each component.",
    "warnings": [
      "Colored hardener activates and colors simultaneously.",
      "Temperature dependent cure times."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior gold evolution ev-9 thick knife grade adhesives": {
    "why_recommend": "Superior Stone Products modified acrylic vinyl ester with colored hardener adhesive. thick knife-grade. For seaming, mitering, laminating, rodding, repair on porcelain, sintered, quartz, dense granite, natural stone, engineered. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (3%-5% GOLD EVOLUTION Colored Hardener by weight). 3) Apply evenly. 4) Working time: 3-5 minutes @ 70 degrees F min. 5) Full cure: 13 minutes average min.13 minutes average.",
    "warnings": [
      "Temperature dependent cure times."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior gold evolution ev-1 flowing adhesives": {
    "why_recommend": "Superior Stone Products modified acrylic vinyl ester with colored hardener adhesive. flowing. For laminating, filling, repair on porcelain, sintered, quartz, dense granite, natural stone, engineered.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (3%-5% GOLD EVOLUTION Colored Hardener by weight). 3) Apply evenly. 4) Working time: 3-5 minutes @ 70 degrees F min. 5) Full cure: 13 minutes average min.13 minutes average. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Temperature dependent cure times.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior gold gv-9 thicker knife grade adhesives": {
    "why_recommend": "Superior Stone Products acrylic vinyl ester adhesive. thick knife-grade (GV-9 = thicker). For seaming, mitering, laminating, rodding, chip repair on natural stone, engineered, granite, marble. Suitable for vertical and horizontal applications. Interior only.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (1%-2% BPO hardener by weight). 3) Apply evenly. 4) Working time: 4-6 minutes @ 70 degrees F min. 5) Full cure: 20-25 minutes @ 70 degrees F min.20-25 minutes @ 70 degrees F.",
    "warnings": [
      "Indoor use only.",
      "Thicker than GV-5 for vertical applications."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior gold gv-1 flowing adhesive for stone laminating and seaming": {
    "why_recommend": "Superior Stone Products acrylic vinyl ester adhesive. flowing. For laminating, seaming, filling on natural stone, engineered, granite, marble. Interior only.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (1%-2% BPO hardener by weight). 3) Apply evenly. 4) Working time: 4-6 minutes @ 70 degrees F min. 5) Full cure: 20-25 minutes @ 70 degrees F min.20-25 minutes @ 70 degrees F. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Indoor use only.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior v-max sv-1 flowing adhesive for outdoor stone fabrication": {
    "why_recommend": "Superior Stone Products vinyl ester adhesive. flowing. For laminating, seaming, outdoor fabrication on natural stone, engineered, granite, marble.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (1%-2% BPO hardener by weight). 3) Apply evenly. 4) Working time: 4-6 minutes @ 70 degrees F min. 5) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Suitable for exterior use.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior pearl flowing adhesive for marble and natural stone seaming": {
    "why_recommend": "Superior Stone Products flowing polyester adhesive. Self-levels into joints. Cure 20-30 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For seaming, laminating, filling on natural stone, marble, granite, limestone. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 1-4% BPO hardener by weight. Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: 4-6 minutes @ 70 degrees F min. Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. Sand from 220-grit up and polish to match. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Indoor use only.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior travertine filler polyester adhesive": {
    "why_recommend": "Superior Stone Products filler for chips, holes, voids in travertine, marble, natural stone. knife-grade. Mix with hardener, apply, cure, sand flush. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean area and remove loose material. 2) Mix filler with hardener at 1-4% BPO hardener by weight. 3) Press into void, slightly overfilling. 4) Working time: 4-6 minutes @ 70 degrees F min. 5) Cure: 20-30 minutes @ 70 degrees F. Sand flush from 220-grit up and polish.",
    "warnings": [
      "Indoor use only.",
      "Specifically formulated for travertine hole filling.",
      "May yellow on light-colored marble over time."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior black polyester knife grade adhesive": {
    "why_recommend": "Superior Stone Products knife-grade polyester adhesive. Stays in place on vertical surfaces. Cure 20-30 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For seaming, laminating, repair on natural stone, granite, dark stone. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 1-4% BPO hardener by weight. Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: 4-6 minutes @ 70 degrees F min. Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. Sand from 220-grit up and polish to match.",
    "warnings": [
      "Indoor use only.",
      "Pre-colored black."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior white polyester flowing adhesive": {
    "why_recommend": "Superior Stone Products flowing polyester adhesive. Self-levels into joints. Cure 20-30 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For laminating, filling, repair on natural stone, marble, granite. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 1-4% BPO hardener by weight. Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: 4-6 minutes @ 70 degrees F min. Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. Sand from 220-grit up and polish to match. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Indoor use only.",
      "Pre-colored white.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior buff polyester knife grade adhesive": {
    "why_recommend": "Superior Stone Products knife-grade polyester adhesive. Stays in place on vertical surfaces. Cure 20-30 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For seaming, laminating, repair on natural stone, granite, marble, travertine. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 1-4% BPO hardener by weight. Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: 4-6 minutes @ 70 degrees F min. Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. Sand from 220-grit up and polish to match.",
    "warnings": [
      "Indoor use only.",
      "Pre-colored buff.",
      "May yellow on light-colored marble over time."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior buff polyester flowing adhesive": {
    "why_recommend": "Superior Stone Products flowing polyester adhesive. Self-levels into joints. Cure 20-30 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For laminating, filling, repair on natural stone, granite, marble, travertine. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 1-4% BPO hardener by weight. Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: 4-6 minutes @ 70 degrees F min. Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. Sand from 220-grit up and polish to match. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Indoor use only.",
      "Pre-colored buff.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior water-clear polyester flowing adhesive": {
    "why_recommend": "Superior Stone Products flowing polyester adhesive. Self-levels into joints. Cure 20-30 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For laminating, filling, repair, resinating on natural stone, marble, granite, white stone. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 1-4% BPO hardener by weight. Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: 4-6 minutes @ 70 degrees F min. Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. Sand from 220-grit up and polish to match. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Indoor use only.",
      "Premium clarity for white/light stones.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior polyester transparent flowing adhesives": {
    "why_recommend": "Superior Stone Products flowing polyester adhesive. Self-levels into joints. Cure 20-30 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For laminating, filling, repair on natural stone, granite, marble. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 1-4% BPO hardener by weight. Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: 4-6 minutes @ 70 degrees F min. Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. Sand from 220-grit up and polish to match. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical.",
    "warnings": [
      "Indoor use only.",
      "May yellow on light-colored marble over time.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior water clear polyester knife grade adhesive": {
    "why_recommend": "Superior Stone Products knife-grade polyester adhesive. Stays in place on vertical surfaces. Cure 20-30 minutes @ 70 degrees F, mix 1-4% BPO hardener by weight. For seaming, laminating, filling, repair on natural stone, marble, granite, white stone. Interior only.",
    "application_tip": "1) Clean surfaces with acetone and ensure completely dry. 2) Scoop desired amount and add BPO hardener at 1-4% BPO hardener by weight. Mix thoroughly 30 seconds. 3) Apply with spatula to joint or repair area. Clamp seams firmly. 4) Working time: 4-6 minutes @ 70 degrees F min. Higher temp = faster set. 5) Scrape excess at gel stage with razor blade. 6) Full cure: 20-30 minutes @ 70 degrees F min.20-30 minutes @ 70 degrees F. Sand from 220-grit up and polish to match.",
    "warnings": [
      "Indoor use only.",
      "Premium clarity for white/light stones.",
      "May yellow on light-colored marble over time."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior acrylic penetrating adhesive - quart": {
    "why_recommend": "Superior Stone Products acrylic adhesive for penetrating repair and filling. super flowing / penetrating. Cure , mix 1-4% BPO hardener by weight. For penetrating repair, resinating, crack filling, strengthening on natural stone, marble, granite. Interior only.",
    "application_tip": "1) Ensure surface is clean and dry. 2) Mix resin with hardener at 1-4% BPO hardener by weight. 3) Apply or pour into cracks/voids. 4) Working time: (see TDS). 5) Cure: . Sand flush and polish.",
    "warnings": [
      "Indoor use only.",
      "Very low viscosity - penetrates deep into stone.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior stone cleanser degreaser for granite marble and natural stone": {
    "why_recommend": "Superior Stone Products cleaner for granite, marble, natural stone. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior e-1000 flowing epoxy parts for stone laminating and seaming": {
    "why_recommend": "Superior Stone Products epoxy (two-part) adhesive. flowing (syrup consistency). For laminating, rodding, crack/chip repair, seaming on natural stone, engineered.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (1:1 by volume (1.15 Part A to 1.0 Part B by weight)). 3) Apply evenly. 4) Working time: 5-10 minutes min. 5) Full cure: 2-4 hours min.2-4 hours. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical. Do not disturb the bond during cure.",
    "warnings": [
      "Suitable for freeze/thaw conditions.",
      "Withstands vibrations and shock loads.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior e-1000 gallon flowing epoxy unit": {
    "why_recommend": "Superior Stone Products epoxy (two-part) adhesive. flowing (syrup consistency). For laminating, rodding, crack/chip repair, seaming on natural stone, engineered.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (1:1 by volume (1.15 Part A to 1.0 Part B by weight)). 3) Apply evenly. 4) Working time: 5-10 minutes min. 5) Full cure: 2-4 hours min.2-4 hours. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical. Do not disturb the bond during cure.",
    "warnings": [
      "Suitable for freeze/thaw conditions.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior e-1000 quart flowing epoxy unit": {
    "why_recommend": "Superior Stone Products epoxy (two-part) adhesive. flowing (syrup consistency). For laminating, rodding, crack/chip repair, seaming on natural stone, engineered.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (1:1 by volume (1.15 Part A to 1.0 Part B by weight)). 3) Apply evenly. 4) Working time: 5-10 minutes min. 5) Full cure: 2-4 hours min.2-4 hours. NOTE: Flowing adhesive - use on horizontal surfaces only. Will run on vertical. Do not disturb the bond during cure.",
    "warnings": [
      "Suitable for freeze/thaw conditions.",
      "Runs on vertical surfaces - use knife-grade for vertical work."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior e-1010 gallon knife grade epoxy unit": {
    "why_recommend": "Superior Stone Products epoxy (two-part) adhesive. knife-grade (paste). For seaming, laminating, mitering, rodding, crack/chip repair on natural stone, engineered, concrete, metals, fiberglass. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (1:1 by volume (1.15 Part A to 1.0 Part B by weight)). 3) Apply evenly. 4) Working time: 5-10 minutes min. 5) Full cure: 2-4 hours min.2-4 hours. Do not disturb the bond during cure.",
    "warnings": [
      "Suitable for freeze/thaw conditions.",
      "No sag on vertical surfaces."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior e-1010 knife grade epoxy parts for stone vertical bonding": {
    "why_recommend": "Superior Stone Products epoxy (two-part) adhesive. knife-grade (paste). For seaming, laminating, mitering, rodding, crack/chip repair, vertical bonding on natural stone, engineered, concrete, metals, fiberglass.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (1:1 by volume (1.15 Part A to 1.0 Part B by weight)). 3) Apply evenly. 4) Working time: 5-10 minutes min. 5) Full cure: 2-4 hours min.2-4 hours. Do not disturb the bond during cure.",
    "warnings": [
      "Suitable for freeze/thaw conditions.",
      "No sag on vertical surfaces."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior e-1010 quart knife grade epoxy unit": {
    "why_recommend": "Superior Stone Products epoxy (two-part) adhesive. knife-grade (paste). For seaming, laminating, mitering, rodding, crack/chip repair on natural stone, engineered, concrete, metals, fiberglass. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (1:1 by volume (1.15 Part A to 1.0 Part B by weight)). 3) Apply evenly. 4) Working time: 5-10 minutes min. 5) Full cure: 2-4 hours min.2-4 hours. Do not disturb the bond during cure.",
    "warnings": [
      "Suitable for freeze/thaw conditions.",
      "No sag on vertical surfaces."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior e-1500s knife grade gallon epoxy unit": {
    "why_recommend": "Superior Stone Products epoxy (two-part) adhesive. knife-grade. For seaming, laminating, mitering, repair on natural stone, engineered. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (per manufacturer instructions). 3) Apply evenly. 4) Working time: (see TDS). 5) Full cure: (see TDS). Do not disturb the bond during cure.",
    "warnings": [
      "For professional use only."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior gold evolution ext 250ml cartridges": {
    "why_recommend": "Superior Stone Products modified acrylic vinyl ester (cartridge format) adhesive. knife-grade (cartridge dispensed). For seaming, mitering, repair, quick jobs on porcelain, sintered, quartz, dense granite, natural stone, engineered. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (pre-metered dual cartridge). 3) Apply evenly. 4) Working time: (see TDS). 5) Full cure: (see TDS).",
    "warnings": [
      "Requires cartridge dispensing gun and mixing nozzle."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "superior lightning instant color enhancer for engineered quartz": {
    "why_recommend": "Superior Stone Products color enhancer deepening natural stone color and veining on engineered quartz. Test first - effect is permanent.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "For engineered quartz only - not natural stone."
    ],
    "source_urls": [
      "https://www.superiorstonproducts.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni idea stonager antistain color intensifier 1 l": {
    "why_recommend": "Bellinzoni color enhancer deepening natural stone color and veining on marble, granite, engineered, natural stone. Test first - effect is permanent.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Surface must be dry and clean before application.",
      "Remove existing stains and mold first.",
      "Wait 24 hours before foot traffic.",
      "For unpolished/textured surfaces."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni mangiamacchia spot remover 250 ml": {
    "why_recommend": "Bellinzoni stain remover for stains on marble, granite, natural stone. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Apply thick layer over stain.",
      "Cover with plastic wrap.",
      "Allow 12-24 hours to draw out stain.",
      "May require repeat applications."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-refresh top gentle cleaner for kitchen and bathroom countertops 750 ml": {
    "why_recommend": "Bellinzoni cleaner for marble, granite, natural stone, engineered quartz, countertops. Safe for daily use.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "For daily maintenance use.",
      "Gentle formula safe for natural stone."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni idea dark antistain deep enhancer protective agent 1 l": {
    "why_recommend": "Bellinzoni color enhancer deepening natural stone color and veining on marble, granite, natural stone, dark colored stone, leather finish stone, rough stone, absorbent stone. Test first - effect is permanent.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Extra dark effect - changes appearance significantly.",
      "Apply between 10-30C.",
      "Turn off underfloor heating before application.",
      "PFAS-free.",
      "Remove excess after 10-15 minutes."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-listo maintenance cream 250 ml": {
    "why_recommend": "Bellinzoni polishing product for restoring shine on marble, granite, agglomerated marble, quartz resin, countertops, tables, window sills.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [
      "Apply with cotton cloth in circular motions.",
      "Allow 10-15 minutes drying before buffing.",
      "Surface must be clean and dry."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-rust remover gel for stone & tile surfaces": {
    "why_recommend": "Bellinzoni stain remover for stains on marble, granite, natural stone, ceramic tile, porcelain tile. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Gel formula for vertical and horizontal surfaces.",
      "Test on inconspicuous area first."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni idea gold antistain protective agent natural color 1 l": {
    "why_recommend": "Bellinzoni sealer protecting marble, granite, natural stone against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours. Does not alter natural color - pearl effect. UV resistant.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Allows stone to breathe.",
      "Apply between 10-30C.",
      "Turn off underfloor heating before application.",
      "Does not alter natural color - pearl effect.",
      "UV resistant."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni idea quarzo color enhancer protective agent 1 l": {
    "why_recommend": "Bellinzoni color enhancer deepening natural stone color and veining on quartz resin, engineered, porcelain stoneware, synthetic stone, marble resin composite. Test first - effect is permanent. UV resistant.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "PFAS-free.",
      "Apply between 10-30C.",
      "Turn off underfloor heating first.",
      "Surface must be free of dirt and salt deposits.",
      "UV resistant."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni idea tropical antistain color intensifier 1 l": {
    "why_recommend": "Bellinzoni color enhancer deepening natural stone color and veining on exotic granite, absorbent granite, natural stone. Test first - effect is permanent. UV resistant. Breathable formula.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "For professional use only.",
      "Test before application.",
      "Wait 24 hours before foot traffic.",
      "UV resistant.",
      "Breathable formula."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni wall clean spray paint, marker and grafitti remover 1 l": {
    "why_recommend": "Bellinzoni cleaner for granite, natural stone, glass, metal, aluminum. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "VOC-free.",
      "Non-drip gel for vertical surfaces.",
      "Minimum 10 minutes dwell time.",
      "Test on painted or plastic surfaces first.",
      "No acids, alkalines, oxidants, or reducers."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni eureka marble polishing gel 1 l": {
    "why_recommend": "Bellinzoni polishing product for restoring shine on marble, limestone, calcareous stone, terrazzo.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [
      "Use with buffing machine or grinder at 800-1500 rpm.",
      "Optimal speed 1000 rpm.",
      "Surface must be polished above grit 400.",
      "Lead-free.",
      "Wash floor with alkaline solution after use."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni marmo care system kit for marble & stone surfaces": {
    "why_recommend": "Bellinzoni care kit for marble, natural stone, countertops.",
    "application_tip": "1) Read included instructions. 2) Clean surface first. 3) Apply products in order specified by kit. 4) Follow timing and application directions for each component.",
    "warnings": [
      "Follow kit instructions for each product in sequence."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni quartz care system kit for engineered quartz surfaces": {
    "why_recommend": "Bellinzoni care kit for engineered quartz, quartz resin, countertops.",
    "application_tip": "1) Read included instructions. 2) Clean surface first. 3) Apply products in order specified by kit. 4) Follow timing and application directions for each component.",
    "warnings": [
      "Specifically formulated for engineered quartz.",
      "Follow kit instructions for each product."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-27 exxtra concentrated acidic based detergent 1 l": {
    "why_recommend": "Bellinzoni cleaner for granite, ceramic, porcelain, cement, acid resistant stone. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "ACID-BASED - DO NOT use on marble, limestone, travertine, or calcium-based stones.",
      "For acid-resistant surfaces only.",
      "Concentrated - requires dilution."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-3 action doccia limescale and heavy water deposits remover 750 ml": {
    "why_recommend": "Bellinzoni cleaner for shower surfaces, bathroom tile, glass, chrome fixtures. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Do not use on marble or acid-sensitive stone.",
      "For bathroom/shower use."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-3 action inox greasy fingerprint and smudge remover 750 ml": {
    "why_recommend": "Bellinzoni cleaner for stainless steel, inox surfaces, metal appliances. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "For stainless steel surfaces only."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-3 action top 3 in 1 formula; cleans, protects and polishes 750 ml": {
    "why_recommend": "Bellinzoni cleaner for marble, granite, natural stone, countertops. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "3-in-1: cleans, protects, and polishes in one step."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-3 action wood clean, protect and polish for wood surfaces 750 ml": {
    "why_recommend": "Bellinzoni cleaner for wood surfaces, wood furniture, wood floors. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "For wood surfaces only - not for stone."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-clean inox multi surface cleaner for all stainless-steel surfaces 750 ml": {
    "why_recommend": "Bellinzoni cleaner for stainless steel, inox, metal surfaces. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "For stainless steel surfaces."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-dural brill surface strengthening polish 1 l": {
    "why_recommend": "Bellinzoni polishing product for restoring shine on marble, granite, natural stone, terrazzo.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [
      "Professional-grade polish.",
      "Apply with buffing machine for best results."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-gtx grout joint cleaner 750 ml": {
    "why_recommend": "Bellinzoni cleaner for cement grout, tile grout joints. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "For cementitious grout joints.",
      "Test on inconspicuous area first."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-grayout grey stain remover for wood surfaces 750 ml": {
    "why_recommend": "Bellinzoni cleaner for wood surfaces, outdoor wood, grey weathered wood. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "For wood surfaces only - not for stone.",
      "Removes grey patina from weathered wood."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-lem3 exxtra mg foaming detergent for floors 1 l": {
    "why_recommend": "Bellinzoni cleaner for marble, granite, natural stone, ceramic, terracotta, concrete. Safe for daily use.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Neutral pH safe for all stone types.",
      "Foaming formula.",
      "Concentrated - requires dilution."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-oil 4 cleaner foaming detergent for oil treated parquet and wood surfaces 1 l": {
    "why_recommend": "Bellinzoni cleaner for oil treated parquet, oil treated wood, wood floors. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Specifically for oil-treated wood surfaces.",
      "Not for stone surfaces."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-pro joint protection for cementitous based joints from oil and water-based stains 750 ml": {
    "why_recommend": "Bellinzoni sealer protecting cement grout, cementitious joints against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "For cementitious grout only, not epoxy grout."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-remoxy cleaning gel for epoxy residues 1 kg": {
    "why_recommend": "Bellinzoni cleaner for porcelain tile, ceramic tile, natural stone, glass mosaic. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "For removing cured epoxy residue.",
      "Apply and allow dwell time.",
      "Do not use on absorbent untreated stone without testing."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-sanychlor mold and mildew stain remover 750 ml": {
    "why_recommend": "Bellinzoni cleaner for marble, granite, natural stone, tile, grout. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Contains chlorine-based active ingredients.",
      "Test on inconspicuous area first.",
      "Rinse after use."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-sanyfloor ph neutral sanitizing detergent 1 l": {
    "why_recommend": "Bellinzoni cleaner for marble, granite, natural stone, ceramic tile, porcelain tile. Safe for daily use. PH neutral - safe for natural stone.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "PH neutral - safe for natural stone.",
      "Concentrated - requires dilution."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-super cleaner degreasing solvent cleaner 1 l": {
    "why_recommend": "Bellinzoni cleaner for marble, granite, natural stone, concrete. Follow dilution instructions. Solvent-based - use in well-ventilated area.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "For heavy-duty degreasing.",
      "Solvent-based - use in well-ventilated area."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-top restorer polishing cream 250 ml": {
    "why_recommend": "Bellinzoni polishing product for restoring shine on marble, granite, natural stone, countertops.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [
      "Apply with soft cloth in circular motions.",
      "Buff to shine after drying."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-wash & polish 2-in-1 detergent and polish for hard floors 1 l": {
    "why_recommend": "Bellinzoni cleaner for marble, granite, natural stone floors, terrazzo, agglomerated marble. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "2-in-1: cleans and polishes in one step.",
      "For hard floors only."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b-xtreme hd cleaner ck high-concentrate cleaner for terracotta, clinker, glazed ceramic and quarry tile 1l": {
    "why_recommend": "Bellinzoni cleaner for terracotta, clinker, glazed ceramic, quarry tile. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "High-concentrate - dilute before use.",
      "Specific for terracotta, clinker, and quarry tile."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni b- lem3 exxtra wd neutral detergent 1l": {
    "why_recommend": "Bellinzoni cleaner for marble, granite, natural stone, gres, terracotta, ceramic, concrete. Safe for daily use.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Neutral pH - safe for all stone types.",
      "Concentrated - requires dilution."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni epox premium set (a and b) epoxy mastic for gluing, jointing and filling": {
    "why_recommend": "Bellinzoni two-component epoxy, 2:1 ratio adhesive. paste (knife grade). For bonding, filling, jointing, reinforcing on granite, marble, agglomerates, terrazzo, concrete, glass, plexiglass, stone honeycomb panels. Suitable for vertical and horizontal applications. Interior only. Polishable after 14-16 hours.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (). 3) Apply evenly. 4) Working time: 30-90 min. 5) Full cure: 2-24 hours. Do not disturb the bond during cure.",
    "warnings": [
      "Mix 2:1 ratio.",
      "Workable 20-30 minutes at 20C.",
      "Movable after 6-8 hours.",
      "Max stability 7 days.",
      "Do not apply below 10C.",
      "Very low yellowing.",
      "Polishable after 14-16 hours."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni eureka granite polishing gel for granite 1 l": {
    "why_recommend": "Bellinzoni polishing product for restoring shine on granite, gres, hard silica containing stone.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [
      "Use with orbital sander at 800-1500 rpm.",
      "Optimal 1000 rpm.",
      "Works on surfaces from grit 220+.",
      "Lead-free.",
      "Alternative to tin oxide."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "bellinzoni eureka quartz resin polishing gel 1 l": {
    "why_recommend": "Bellinzoni polishing product for restoring shine on quartz resin, engineered quartz, silestone, okite, sm quartz.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [
      "Use with orbital sander at 800-1500 rpm.",
      "Optimal 1000 rpm.",
      "For countertops: 10-15g per application."
    ],
    "source_urls": [
      "https://www.bellinzoni.com"
    ],
    "last_verified": "2026-04-06"
  },
  "fila norust rust stain remover for natural stone and tile": {
    "why_recommend": "FILA stain remover for stains on natural stone, polished marble, limestone, travertine, porcelain tile, concrete, terrazzo, terracotta. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Non-acidic - safe for marble, limestone, travertine.",
      "Turns purple when reacting with rust.",
      "15-minute dwell time.",
      "Repeat for stubborn stains.",
      "May strip wax from treated surfaces."
    ],
    "source_urls": [
      "https://www.filasolutions.com"
    ],
    "last_verified": "2026-04-06"
  },
  "fila deterdek qt. - cement grout haze remover": {
    "why_recommend": "FILA cleaner for porcelain tile, ceramic tile, granite, quartzite, acid resistant stone, quarry tile, terracotta. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Do NOT use on marble, limestone, or travertine.",
      "Only for cement-based grouts.",
      "Alternative to muriatic acid.",
      "No harmful fumes."
    ],
    "source_urls": [
      "https://www.filasolutions.com"
    ],
    "last_verified": "2026-04-06"
  },
  "fila ps87 1 gallon heavy duty stone and tile cleaner concentrate": {
    "why_recommend": "FILA cleaner for porcelain tile, glazed ceramic, unpolished agglomerates, unpolished natural stone, concrete, linoleum, pvc, terracotta, quarry tile. Follow dilution instructions. Biodegradable.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Do not use on polished marble or polished stone.",
      "Do not use on wood.",
      "Concentrated - dilute 1:5 to 1:20.",
      "Biodegradable."
    ],
    "source_urls": [
      "https://www.filasolutions.com"
    ],
    "last_verified": "2026-04-06"
  },
  "fila kitchenkare 24 oz. - kitchen stain remover": {
    "why_recommend": "FILA cleaner for porcelain tile, ceramic tile, plastic, metal, kitchen surfaces. Safe for daily use. Biodegradable.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Spray and wipe application.",
      "Gentle on hands.",
      "Pleasantly scented.",
      "Biodegradable."
    ],
    "source_urls": [
      "https://www.filasolutions.com"
    ],
    "last_verified": "2026-04-06"
  },
  "fila groutrenew - grout cleaner & deep stain remover spray": {
    "why_recommend": "FILA cleaner for porcelain tile, ceramic tile, cementitious grout, mosaic. Follow dilution instructions. Biodegradable.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Non-acidic formula.",
      "Do NOT use on polished marble, travertine, or limestone.",
      "Do NOT use on waxed surfaces.",
      "Causes plastic/polished surfaces to dull.",
      "Seal grout after cleaning with GROUT PROOF.",
      "Biodegradable."
    ],
    "source_urls": [
      "https://www.filasolutions.com"
    ],
    "last_verified": "2026-04-06"
  },
  "fila epoxyoff qt. - epoxy grout haze remover": {
    "why_recommend": "Epoxy grout haze remover for porcelain, engineered stone, sintered, and concrete surfaces ONLY. CRITICAL: Do NOT use on marble, granite, quartzite, or any natural stone - will cause damage. Water-based alkaline gel, 30-minute action time, biodegradable.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "CRITICAL: Do NOT use on marble, granite, quartzite, limestone, or any natural stone.",
      "Do NOT use on absorbent materials (natural stone, wood, plastic).",
      "Wait 24 hours after grouting before use.",
      "Ensure grout is fully cured.",
      "30-minute action time.",
      "Biodegradable."
    ],
    "source_urls": [
      "https://www.filasolutions.com"
    ],
    "last_verified": "2026-04-06"
  },
  "fila showerclean & shine 24 oz. - bathroom soap scum remover": {
    "why_recommend": "FILA cleaner for porcelain tile, ceramic tile, natural stone, glass, shower surfaces. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "For bathroom and shower surfaces.",
      "Spray and wipe."
    ],
    "source_urls": [
      "https://www.filasolutions.com"
    ],
    "last_verified": "2026-04-06"
  },
  "fila refresh & reseal 24 oz. - neutral cleaner & resealer spray": {
    "why_recommend": "FILA cleaner for marble, granite, limestone, travertine, quartzite, quartz, marble resin. Safe for daily use. No rinsing required. Biodegradable.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Spray and wipe with dry cloth.",
      "PFOA and PFOS free.",
      "Food-contact safe.",
      "No rinsing required.",
      "Biodegradable."
    ],
    "source_urls": [
      "https://www.filasolutions.com"
    ],
    "last_verified": "2026-04-06"
  },
  "fila cleanall spray 24 oz. - neutral everyday cleaner": {
    "why_recommend": "FILA cleaner for porcelain tile, ceramic tile, natural stone, marble, granite, wood, laminate. Safe for daily use. PH neutral - safe for natural stone. No rinsing needed. Biodegradable.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "PH neutral - safe for natural stone.",
      "No rinsing needed.",
      "Biodegradable."
    ],
    "source_urls": [
      "https://www.filasolutions.com"
    ],
    "last_verified": "2026-04-06"
  },
  "fila - contractor's choice sealer - 1 gallon": {
    "why_recommend": "FILA Solutions sealer protecting natural stone, cement grout, concrete, terracotta against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours. Water-based, VOC-free. Odorless.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "PFOA and PFOS not intentionally added.",
      "Water-based, VOC-free.",
      "Odorless."
    ],
    "source_urls": [
      "https://www.filasolutions.com"
    ],
    "last_verified": "2026-04-06"
  },
  "k-bond vivid vinyl ester adhesive knife grade": {
    "why_recommend": "K-Bond vinyl ester, knife grade adhesive. knife grade (thick paste). For bonding, seam-joining, laminating on granite, marble, quartzite, engineered, natural stone. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (). 3) Apply evenly. 4) Working time: 5-10  min.5) Full cure: 15-30 min.",
    "warnings": [
      "Vinyl ester - superior UV resistance vs polyester.",
      "Better outdoor durability than polyester.",
      "Requires hardener/catalyst."
    ],
    "source_urls": [
      "https://www.kbondadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "k-bond polyester stone adhesive transparent paste - quart": {
    "why_recommend": "K-Bond polyester, transparent, paste adhesive. paste (knife grade). For bonding, seam-joining, filling, chip-repair on granite, marble, natural stone, engineered. Suitable for vertical and horizontal applications. Interior only. Can be tinted with pigments.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (). 3) Apply evenly. 4) Working time: 3-8  min.5) Full cure: 15-30 min.",
    "warnings": [
      "Requires hardener/catalyst (BPO).",
      "Can be tinted with pigments.",
      "Quart size."
    ],
    "source_urls": [
      "https://www.kbondadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "k-bond - icon colorless knife grade styren free adhesive": {
    "why_recommend": "K-Bond styrene-free, knife grade adhesive. knife grade (thick paste). For bonding, seam-joining, filling on granite, marble, quartzite, engineered, quartz. Interior only.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (). 3) Apply evenly. 4) Working time: 5-10 min. 5) Full cure: 15-30 min.",
    "warnings": [
      "Styrene-free - low odor, better indoor air quality.",
      "Requires hardener/catalyst."
    ],
    "source_urls": [
      "https://www.kbondadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "k-bond elite stone adhesive knife grade for granite and marble seams": {
    "why_recommend": "K-Bond polyester, knife grade, premium adhesive. knife grade (thick paste). For bonding, seam-joining on granite, marble, natural stone. Suitable for vertical and horizontal applications. Interior only.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (). 3) Apply evenly. 4) Working time: 3-8  min.5) Full cure: 15-30 min.",
    "warnings": [
      "Premium formula for stone seams.",
      "Requires hardener/catalyst."
    ],
    "source_urls": [
      "https://www.kbondadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "k-bond high performance polyester white paste stone adhesive": {
    "why_recommend": "K-Bond polyester, paste, white adhesive. paste. For bonding, filling, repair on granite, marble, natural stone, light colored stone. Suitable for vertical and horizontal applications. Interior only.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (). 3) Apply evenly. 4) Working time: 3-8  min.5) Full cure: 15-30 min.",
    "warnings": [
      "White color - for light-colored stone.",
      "Requires hardener/catalyst."
    ],
    "source_urls": [
      "https://www.kbondadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "k-bond ultimate perormance poly-epoxy knife grade - quart": {
    "why_recommend": "K-Bond poly-epoxy hybrid, knife grade adhesive. knife grade (thick paste). For bonding, seam-joining, laminating on granite, marble, quartzite, engineered, natural stone. Suitable for vertical and horizontal applications.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (). 3) Apply evenly. 4) Working time: 30-90 min. 5) Full cure: 2-24 hours. Do not disturb the bond during cure.",
    "warnings": [
      "Requires hardener/catalyst.",
      "Poly-epoxy hybrid - combines polyester speed with epoxy strength.",
      "Quart size."
    ],
    "source_urls": [
      "https://www.kbondadhesives.com"
    ],
    "last_verified": "2026-04-06"
  },
  "kraken bond ultra grab high tack - white construction adhesive 300ml 10.1 fl oz": {
    "why_recommend": "Kraken Bond construction adhesive, high-tack, MS polymer adhesive. paste (cartridge). For bonding, construction, mounting on wood, metal, concrete, stone, ceramic, pvc, foam, most building materials. Paintable. Interior and exterior use.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (). 3) Apply evenly. 4) Working time: 5-10 min. 5) Full cure: 24 hours.",
    "warnings": [
      "High initial grab - holds without bracing.",
      "Isocyanate-free.",
      "Paintable.",
      "Interior and exterior use."
    ],
    "source_urls": [
      "https://www.krakenbond.com"
    ],
    "last_verified": "2026-04-06"
  },
  "hsk-2 hot stuff pro kit- complete ca glue set with stone accelerator and debonder": {
    "why_recommend": "Satellite City care kit for granite, marble, natural stone, engineered, wood, ceramic.",
    "application_tip": "1) Read included instructions. 2) Clean surface first. 3) Apply products in order specified by kit. 4) Follow timing and application directions for each component.",
    "warnings": [
      "Kit includes multiple CA viscosities plus stone accelerator and debonder.",
      "Follow instructions for each component."
    ],
    "source_urls": [
      "https://www.satellitecity.com"
    ],
    "last_verified": "2026-04-06"
  },
  "hot stuff instant glue (thin, medium, thick) - 2 oz": {
    "why_recommend": "Cyanoacrylate (CA) instant glue for TEMPORARY bonding, tacking during dry-fit, and small chip repairs only. Available in thin (wicking), medium (gap-filling), and thick (gel) viscosities. NOT for permanent seams - use methacrylate or epoxy for structural bonds.",
    "application_tip": "1) Clean surfaces with acetone. 2) Mix components per instructions (). 3) Apply evenly. 4) Working time: 5-30 sec. 5) Full cure: 1-2 min.",
    "warnings": [
      "Thin: wicks into hairline cracks, 5-second bond.",
      "Medium: fills small gaps, 10-15 second bond.",
      "Thick: fills larger gaps, 30-60 second bond.",
      "Bonds skin instantly - use with care.",
      "Use accelerator for instant full cure.",
      "TEMPORARY BOND ONLY - not for permanent seams."
    ],
    "source_urls": [
      "https://www.satellitecity.com"
    ],
    "last_verified": "2026-04-06"
  },
  "satellite city hot stuff pro kit complete ca glue set with accelerator and debonder": {
    "why_recommend": "Satellite City care kit for granite, marble, natural stone, engineered, wood, ceramic.",
    "application_tip": "1) Read included instructions. 2) Clean surface first. 3) Apply products in order specified by kit. 4) Follow timing and application directions for each component.",
    "warnings": [
      "Includes accelerator and debonder.",
      "Follow instructions for each component."
    ],
    "source_urls": [
      "https://www.satellitecity.com"
    ],
    "last_verified": "2026-04-06"
  },
  "dry-treat - stain-proof original - premium impregnating sealer - qt": {
    "why_recommend": "Stain-Proof sealer protecting granite, marble, limestone, travertine, sandstone, slate, concrete, grout, brick, terracotta, natural stone against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours. Does not alter appearance. Breathable.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Premium impregnating sealer.",
      "15-year warranty when professionally applied.",
      "Does not alter appearance.",
      "Breathable."
    ],
    "source_urls": [
      "https://www.drytreat.com"
    ],
    "last_verified": "2026-04-06"
  },
  "dry-treat - stain-proof plus - premium countertop/dense impregnating sealer - 16oz": {
    "why_recommend": "Stain-Proof sealer protecting polished granite, polished marble, engineered, dense natural stone, porcelain against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours. Does not alter appearance.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "For dense, polished, and low-porosity surfaces.",
      "Penetrates where standard sealers cannot.",
      "Does not alter appearance."
    ],
    "source_urls": [
      "https://www.drytreat.com"
    ],
    "last_verified": "2026-04-06"
  },
  "dry-treat - eff-erayza rust remover - safe acid stone & masonry cleaner - qt": {
    "why_recommend": "Stain-Proof cleaner for natural stone, granite, masonry, concrete, grout. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Safe acid formula - won't damage polished stone when used as directed.",
      "Test first.",
      "Do NOT use on marble, limestone, travertine, or calcite-based stone - acid will etch.",
      "Quart size."
    ],
    "source_urls": [
      "https://www.drytreat.com"
    ],
    "last_verified": "2026-04-06"
  },
  "stain-proof porcelain & quartz sealer - 1 quart (formerly porcelain plus)": {
    "why_recommend": "Stain-Proof sealer protecting porcelain tile, engineered quartz, ultra compact surfaces, sintered against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "For ultra-dense surfaces that resist standard sealers.",
      "Formerly called Porcelain Plus."
    ],
    "source_urls": [
      "https://www.drytreat.com"
    ],
    "last_verified": "2026-04-06"
  },
  "dry-treat - oxy-klenza stain remover - triple action cleaner - 2.2lb": {
    "why_recommend": "Stain-Proof cleaner for natural stone, marble, granite, limestone, concrete, grout, masonry. Follow dilution instructions.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Oxygen-based - safe for natural stone.",
      "Mix with water to form paste/solution.",
      "Triple action: cleans, deodorizes, whitens."
    ],
    "source_urls": [
      "https://www.drytreat.com"
    ],
    "last_verified": "2026-04-06"
  },
  "miracle sealants stone polish color and gloss enhancer (quart)": {
    "why_recommend": "Miracle Sealants (Rust-Oleum) color enhancer deepening natural stone color and veining on granite, marble, natural stone, engineered. Test first - effect is permanent.",
    "application_tip": "1) Clean surface and let dry completely. 2) Test in inconspicuous area first. 3) Apply thin coat with cloth or brush. 4) Wait 10-15 minutes, wipe excess. 5) Allow 24 hours before use. Effect is permanent - test first.",
    "warnings": [
      "Topical product - not a penetrating sealer.",
      "Reapply as needed for maintenance."
    ],
    "source_urls": [
      "https://www.miraclesealants.com"
    ],
    "last_verified": "2026-04-06"
  },
  "miracle sealants 511qt6 511 impregnator sealer, quart, clear (new version, improved)": {
    "why_recommend": "Miracle Sealants (Rust-Oleum) sealer protecting granite, marble, limestone, slate, travertine, concrete, ceramic tile, porcelain tile, grout, quartz, terrazzo against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours. Available in water-based and oil-based versions.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Invisible barrier - does not change surface appearance.",
      "Dry to touch 1-3 hours.",
      "Full cure 72 hours.",
      "Available in water-based and oil-based versions."
    ],
    "source_urls": [
      "https://www.miraclesealants.com"
    ],
    "last_verified": "2026-04-06"
  },
  "miracle sealants plusgal4 511 porous plus sealer, gallon, yellow": {
    "why_recommend": "Miracle Sealants (Rust-Oleum) sealer protecting granite, marble, quartzite, travertine, limestone, slate, grout, porous natural stone against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours. Solvent-based: VOC <750 g/L.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "For porous surfaces.",
      "Will not alter natural look.",
      "Not a surface coating.",
      "Solvent-based: VOC <750 g/L."
    ],
    "source_urls": [
      "https://www.miraclesealants.com"
    ],
    "last_verified": "2026-04-06"
  },
  "miracle sealants coukl32oz6 spray counter kleen, 32 ounce, 32 fl oz": {
    "why_recommend": "Miracle Sealants (Rust-Oleum) cleaner for granite, quartz, natural stone, engineered, tile, backsplash. Safe for daily use. PH neutral - acid-free. No rinsing required. Streak-free.",
    "application_tip": "1) Dilute per label instructions if concentrate. 2) Apply to surface with mop, cloth, or spray. 3) Agitate with soft brush or pad if needed. 4) Rinse thoroughly with clean water. 5) Dry surface. Repeat for heavy soiling.",
    "warnings": [
      "Safe for sealed and unsealed stone.",
      "PH neutral - acid-free.",
      "No rinsing required.",
      "Streak-free."
    ],
    "source_urls": [
      "https://www.miraclesealants.com"
    ],
    "last_verified": "2026-04-06"
  },
  "crown acetone solvent cleaner 1 gallon for stone fabrication": {
    "why_recommend": "Crown solvent for use on granite, marble, natural stone, metal, glass.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "Highly Flammable.",
      "Use in well-ventilated area.",
      "Avoid contact with skin and eyes.",
      "Keep away from ignition sources.",
      "Not for use on plastic, rubber, or painted surfaces."
    ],
    "source_urls": [],
    "last_verified": "2026-04-06"
  },
  "crown denatured alcohol 1 gallon (3.78 l)": {
    "why_recommend": "Crown solvent for use on granite, marble, natural stone, glass, metal.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "Use in well-ventilated area.",
      "Evaporates quickly leaving no residue.",
      "Good for pre-sealer surface prep."
    ],
    "source_urls": [],
    "last_verified": "2026-04-06"
  },
  "tilerepairkit - professional tile & surface repair wax kit with soldering iron": {
    "why_recommend": "Mechanic repair-kit for use on ceramic tile, porcelain tile, laminate, wood, vinyl, countertops.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "Includes soldering iron for melting wax.",
      "Mix colors to match surface.",
      "For small cosmetic repairs only."
    ],
    "source_urls": [],
    "last_verified": "2026-04-06"
  },
  "icr sprint l17 anti-drop solvent base sealer": {
    "why_recommend": "ICR sealer protecting marble, granite, natural stone, concrete against stains and water. Apply, wait, wipe excess. Full cure 4-24 hours. Solvent-based.",
    "application_tip": "1) Clean surface thoroughly and let dry completely. 2) Apply sealer evenly with cloth or brush. 3) Let penetrate 5-15 minutes. 4) Wipe off excess before it dries. 5) Allow full cure (24 hours) before use. Apply second coat if needed.",
    "warnings": [
      "Anti-drip formula for vertical surfaces.",
      "Italian manufacturer.",
      "Solvent-based."
    ],
    "source_urls": [
      "https://www.icr-sprint.it"
    ],
    "last_verified": "2026-04-06"
  },
  "italian craftsman stone polish for granite and marble surfaces": {
    "why_recommend": "Italian Craftsman polishing product for restoring shine on granite, marble, natural stone, countertops.",
    "application_tip": "1) Clean surface thoroughly. 2) Apply small amount of product to surface or pad. 3) Work in circular motions with polishing pad. 4) Buff to desired shine. 5) Wipe clean with dry cloth.",
    "warnings": [
      "For maintenance polishing, not restoration.",
      "Spray and wipe application."
    ],
    "source_urls": [
      "https://www.italiancraftsman.com"
    ],
    "last_verified": "2026-04-06"
  },
  "akfix 710 stone & marble chip repair kit": {
    "why_recommend": "Akfix repair-kit for use on granite, marble, natural stone, engineered, quartz.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "Follow mixing instructions for color matching.",
      "For cosmetic surface repairs."
    ],
    "source_urls": [
      "https://www.akfix.com"
    ],
    "last_verified": "2026-04-06"
  },
  "rust stain remover (rsr-2000) rust stain remover in gel form": {
    "why_recommend": "Alpha Professional Tools stain remover for stains on granite, marble, natural stone, concrete, tile. Apply, cover, wait, rinse.",
    "application_tip": "1) Clean surface first to remove loose debris. 2) Apply thick layer of product over stain. 3) Cover with plastic wrap to keep moist. 4) Wait 12-24 hours for product to draw out stain. 5) Remove, rinse with clean water. Repeat if needed.",
    "warnings": [
      "Gel formula stays in place on vertical surfaces.",
      "Apply and allow dwell time.",
      "Rinse thoroughly after use."
    ],
    "source_urls": [
      "https://www.alpha-tools.com"
    ],
    "last_verified": "2026-04-06"
  },
  "turboshine polishing and scratch removal system for natural and engineered stone countertops": {
    "why_recommend": "Alpha Professional Tools polishing-system for use on granite, marble, natural stone, engineered, quartz countertops.",
    "application_tip": "1) Read product instructions. 2) Prepare surface. 3) Apply per directions. 4) Allow proper cure/dry time. 5) Clean up excess.",
    "warnings": [
      "Multi-step system - follow grit sequence.",
      "Use with variable-speed polisher.",
      "For countertop restoration."
    ],
    "source_urls": [
      "https://www.alpha-tools.com"
    ],
    "last_verified": "2026-04-06"
  }
};
